import { Injectable, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Global } from '../global/globalApi';
import { AlertMsg } from '../models/Constants';
import {
  CallCustomerAttributes,
  CustomerDataModel,
  GEN_attributes,
  InteractionDTO,
  personData,
} from '../models/customer.model';
import { NewAgentApiService } from './new-agent-api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, retry, Subject, Subscription } from 'rxjs';
import { LogService } from './log.service';
import { Tab } from '../models/tab.model';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { CustomerAccountBusinessLogicService } from './customer-account-business-logic.service';
import { AwsSqsService } from './aws-sqs.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InteractionHistoryService } from './interaction-history.service';
import { TbaBusinessLogicService } from './tba-business-logic.service';
import { TimerService } from './timer.service';
import { CustomerAlertsService } from './customer-alerts.service';
import { AppointmentsCardService } from './appointments-card.service';
import { AaaSService } from './aaas.service';
import { AccountFreezeService } from './account-freeze.service';



@Injectable({
  providedIn: 'root',
})
export class CustBusService implements OnDestroy {
  public customerDetails: CustomerDataModel[] = [];
  public personData: personData = new personData();
  public subscription!: Subscription;
  public subscription2!: Subscription;
  public clients: Array<any> = new Array<any>();
  public csAcRouting = new BehaviorSubject<any>({});
  public className = "CustBusService";


  public customers: Array<any> = [
    { value: 0, customerValue: 'Select Customer Type' },
    { value: 1, customerValue: 'Accountholder' },
    { value: 2, customerValue: 'Beneficiary' },
    { value: 3, customerValue: 'Client' },
    { value: 4, customerValue: 'Government Agency' },
    { value: 5, customerValue: 'Legal Guardian-Full Access' },
    { value: 6, customerValue: 'Legal Guardian-Limited Access' },
    { value: 7, customerValue: 'Power of Attorney' },
    { value: 8, customerValue: 'Representative of the Estate' },
    { value: 9, customerValue: 'Spouse/Partner' },
    { value: 10, customerValue: 'Union Representative' },
    { value: 10, customerValue: 'Unknown Caller' },
    { value: 10, customerValue: '3rd Party' },
  ];
  public liveCall: any;
  liveClient: any;
  public liveChat: any;
  public liveChatClient = new Array();
  public customerCmpt: any;
  authenticateStatus: any;
  public parentData: any; //to handle the live call/chat additional account
  public openAdditonalAcc: any;
  reasonForAdditional: object = new Object({
    firstReason: '',
    secondReason: '',
  });
  public conversationId: string = '';
  public phoneNumber: string = '';
  interactionModel!: InteractionDTO;
  public direction: string = '';
  public dynamicATT = new Array<any>();
  public goToCustOverView = new Subject<boolean>();
  constructor(
    public apiService: NewAgentApiService,
    public rootScope: RootScopeService,
    private router: Router,
    private http: HttpClient,
    public logger: LogService,
    public encryptDecryptService: EncryptDecryptService,
    public custAccService: CustomerAccountBusinessLogicService,
    private awsService: AwsSqsService,
    public intHistService: InteractionHistoryService,
    public custAlertsService: CustomerAlertsService,
    public tbaService: TbaBusinessLogicService,
    private timerService: TimerService,
    private appointmentsCardService: AppointmentsCardService,
    public logService : LogService , public aaaSService:AaaSService,
    public accountFreezeService: AccountFreezeService
  ) {
    this.genesysCallOrChat();
    this.updateCustData()
 
  }

  //CS_SECURITY_LEVEL
  Gensysvalidation(self) {
    // console.log('method Gensysvalidation called', this.liveClient);
    if (this.rootScope?.isLiveCall || this.rootScope?.isLiveChat) {
      return this.clients?.find((x) => x.clientId == this.liveClient);
    } else return false;
  }
  /*@data :fotmdetails
  @self:Refer to component variables */

  getSearchData(data: any, self): any {
    let model = JSON.parse(JSON.stringify(data));

    if (model.clientName) {
      let clientId = this.clients?.filter(item => item?.clientName == model.clientName);
      model.clientId = clientId[0] ? clientId[0]?.clientId : '';
      if(this.customerCmpt?.customerSearchForm){
        this.customerCmpt.customerSearchForm.value.clientId = model.clientId;
      }
    }

    self.dataSource = new MatTableDataSource();
    if (model.dateOfBirth)
      model.dateOfBirth = this.rootScope.dateFormatter(
        model.dateOfBirth,
        'yyyy-MM-dd'
      );

    model.userSessionId = this.rootScope.sessionId
      ? this.rootScope.sessionId
      : 'abc123defgh';

    model.serviceName = 'search-account';
    //model.apiVersion = "1.5";
    this.rootScope.isErrorToHide = true;
    this.rootScope.isGensysUDPErrorToHide = true;
    /* istanbul ignore next */
    this.rootScope.custSearchLoaderTimeoutId = setTimeout(() => {
        /* istanbul ignore next */
      this.rootScope.showCustSearchLoaderMsg = true;
    }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);
    this.rootScope.custSearchLoader = true;
    this.apiService
      .postApi(Global.customerApi.fetchCustomerData, model, false, Constants.apiVersions, false)
      .subscribe({
        next: (res) => {
           /* istanbul ignore next */
          clearTimeout(this.rootScope.custSearchLoaderTimeoutId);
           /* istanbul ignore next */
          this.rootScope.custSearchLoader = false;
           /* istanbul ignore next */
          this.rootScope.showCustSearchLoaderMsg = false;
          /* istanbul ignore next */
          if (res) {
            clearTimeout(this.rootScope.custSearchLoaderTimeoutId);
          this.rootScope.custSearchLoader = false;
          this.rootScope.showCustSearchLoaderMsg = false;
            res = this.apiService.errorValidation(res);
            res = this.decryptPlatformExternalIds(res);
            if (res.message == AlertMsg.moreThen50)
              this.rootScope.enableAlerts(Constants.WARNING, res.message);
            this.customerDetails = res?.udpSearchResponseList
              ? res.udpSearchResponseList
              : [];
            self.dataSource = new MatTableDataSource(this.customerDetails);

            this.setTableData(self, res.totalCount);
          } else {
            this.rootScope?.scrollToTop();
          }
        },
        error: (error) => {
          clearTimeout(this.rootScope.custSearchLoaderTimeoutId);
          this.rootScope.custSearchLoader = false;
          this.rootScope.showCustSearchLoaderMsg = false;
          this.rootScope.enableAlerts(Constants.ERROR, AlertMsg.error500);
          self.rootService?.scrollToTop();
        },
      });
  }

  setTableData(self, totalCount) {
    self.totalRecords = totalCount;
    this.rootScope.totalCount = totalCount;
    setTimeout(() => {
      if (totalCount >= 0 && totalCount <= 50) {
        self.rootService?.scrollToBottom();
      } else {
        self.rootService?.scrollToTop();
      }
      if (self.alightTable) {
        self.alightTable?.setGridSortAndPagination();
        self.alightTable.selectedRow = null;
      }
    }, 10);
  }

  clearCustomerSearch() {
    this.rootScope.callChatReceived = true;
    this.rootScope.clearCustomerSearchState();
    this.rootScope.customerSearchClientId = '';
  }

  /*start gensys function  */
  public genesysCallOrChat() {
    // Reset liveClient before fetching a new clientId
    this.liveClient = null;
    this.subscription = this.rootScope.getLiveChatDetails().subscribe((res) => {
      if (res) {
        this.liveClient = null;
        /* istanbul ignore next */
        if (res.clientValue) {
          this.conversationId = res.conversationId;
          this.direction = 'inbound'; //res.clientValue?.direction;
          this.liveChat = res.clientValue?.attributes;
          this.logService.debugLogs("Chat Attributes , = "+ JSON.stringify(this.liveChat), this.className)
          if (
            this.liveChat[Constants.ALS_chat.ClientID] &&
            this.rootScope.isLiveChat
          ) {
            this.dynamicATT = new Array<any>();
            /**Below method explicitly handles clearing of customer search page on receiving call or chat ***/
            this.clearCustomerSearch();
            
            
           
        
            if (!this.getChatClientId(this.liveChat[Constants.ALS_chat.ClientID]) && !this.rootScope.isScreenpopAttributeEnabled) {
              this.unknownClient(Constants.SCREENPOP_ERRORMSG);
            }
            else if(!this.liveClient){
              this.unknownClient(Constants.CHAT_ACCESS_ERRORMSG);
            } 
            else {

              this.logService.debugLogs("Chat Attributes when client is present = "
                +JSON.stringify(this.liveChat), this.className)
                this.logService.debugLogs("Client item = "
                  +JSON.stringify(this.liveClient), this.className)

              this.rootScope.conversationConfig(this.liveClient);

              if (this.liveChat?.[Constants.ALS_chat.PrsnId]) {
                this.getPersonData(null, res);
              }
              else if (this.leavProChatValidation(res.clientValue?.attributes)) {
                this.getCustomerDataForLP(res);
              }

            
            if (
              !this.rootScope.liveChatCTS.find(
                (xx) => xx?.clientId == this.liveClient
              ) 
            ) {
              this.rootScope.liveChatCTS.push(this.clients.find((xx) => xx.clientId == this.liveClient));
              //if (this.rootScope.liveChatCTS.length >= 2)
              // this.tempClients = this.clients.filter(xx => (this.liveChatClient.includes(xx.clientId)))
           
             } }
             this.logService.errorLogs("Live Client = " +JSON.stringify(this.liveClient), this.className);
          }
        } 
        else {
          this.liveChat = null;
        }

        if (this.customerCmpt) this.customerCmpt.liveCallFn();
      }
    });

    /****
     * if the callObject has ENC_CS_CUSTOMER_ID field
     * it means security level is SL2 to 4.
     */
    this.subscription2 = this.rootScope
      .getLiveCallDetails()
      .subscribe((res) => {
        /* istanbul ignore next */
        this.logService.debugLogs("GetLiveCalDetails Subscription , res =" + JSON.stringify(res) , this.className);
        if (res) {
          this.liveClient = null;
          this.conversationId = res.conversationId;
          this.phoneNumber = res.clientValue?.address;
          this.direction = res.clientValue?.direction;
          this.liveCall = res.clientValue?.attributes;
           /* istanbul ignore next */
          
          // this.logService.debugLogs("LiveCall Attributes  =" +JSON.stringify(this.liveCall), this.className);

          

          if (this.liveCall) {
            this.dynamicATT = new Array<any>();
            // console.log(
            //   'this.rootService.callChatReceived',
            //   this.rootScope.callChatReceived
            // );
            /**Below method explicitly handles clearing of customer search page on receiving call or chat ***/
            /* istanbul ignore next */
            this.clearCustomerSearch();
          }
          // this.liveCall.ENC_CS_CUSTOMER_ID = false;
          let isClientPresent: boolean = false;
           /* istanbul ignore if */
          if (this.getClientId() && this.Gensysvalidation(null)) {
            isClientPresent = true;
            this.logService.debugLogs("Client Validated and LiveClient   =" +  this.liveClient, this.className);
            this.rootScope.conversationConfig(this.liveClient);
          }

          //console.log('isClientPresent', isClientPresent);
          /* istanbul ignore next */
          if (res.clientValue?.attributes) {
           
                  let obj:any = {
                  'conversationId': res.conversationId,
                  'attributes': res.clientValue?.attributes,
                  'timeStamp': new Date().toISOString(),
                  'globalId': this.liveCall?.UDP_GBL_ID || '',
                  
                }
                this.logService.debugLogs("Live Call attribute details =" + JSON.stringify(obj), this.className);
                let newObj = this.rootScope.createLogsObject(JSON.stringify(obj), "telephony", this.rootScope.activeCustTab,res.conversationId);
                this.awsService.sendAngularLogsToSQS(newObj);

            if (
              (this.liveCall?.ENC_CS_CUSTOMER_ID || this.liveCall?.UDP_GBL_ID) &&
              this.rootScope.activeChatOrCall() == 0 &&
              isClientPresent
            ) {
              // this.timerService.startTimerAtCallLand(res.clientValue?.connectedTime);
              if (this.rootScope.callType == Constants.OUTBOUND_CALL_TYPE) this.outboundTab(res);//outbound transfer will pick from live user direcion 
              //to handle outbound all scenarios outbound transfer and confrence
              else this.getPersonData(null, res);
            }/**
            Below case to validate client config base ALS -attribute  
             */
            else if (this.leavProCallValidation(isClientPresent)) {
              this.getCustomerDataForLP(res);
            }
            else if (!this.liveCall?.ENC_CS_CUSTOMER_ID || !isClientPresent) {
              if (!isClientPresent && !this.rootScope.isScreenpopAttributeEnabled) {
                this.unknownClient(Constants.SCREENPOP_ERRORMSG);
              } else if (!isClientPresent) {
                 if (this.rootScope.unknownClientQueues?.length > 0 &&
                  this.rootScope.unknownClientQueues.includes(this.liveCall?.QUEUE_NAME)) {
                    this.rootScope.isUnknownClientCall_PId = res;
                  this.unknownCallScreenPop(Constants.INBOUND_CALL_SUB_ACCESS_ERRORMSG);
                }else {
                  this.unknownCallScreenPop();
                }
               

              }
              // this.timerService.startTimerAtCallLand(res.clientValue?.connectedTime);
              // console.log('SL cll received', this.liveCall?.ENC_CS_CUSTOMER_ID);
              if (this.customerCmpt && this.rootScope.customerLink == 0)
                this.customerCmpt.clearAll();

              this.getClientId();
              // Removed below code for CCR1-2683
              /* if (this.rootScope.checkMaxCustAccount()) {
                 this.rootScope.holdLiveDetails.push(new Tab());
                 this.rootScope.holdLiveDetails[0].id = 1;
                 this.showPopup();
               }*/
              if (isClientPresent) {
               
                if (this.rootScope.isCallBackCall) {
                  /** Case of SL1 callback call where duplicate CS tab will open ***/
                  this.handleUnIdentifiedCallBackCall(res);
                } else {
                  this.handleUnIdentifiedCall(res);
                }
                //  this.rootScope.customerLink = 1;
              }
            }
          } else this.liveCall = null;
          if (this.customerCmpt) this.customerCmpt.liveCallFn();
        }
        else {
          this.liveCall = null;
        }
      });
  }

  unknownCallScreenPop(submsg?) {
    // CCR1-12947 - message for alternate outbound call scenario when clientId is not present in the queue attributes
    if (this.rootScope.callType == Constants.OUTBOUND_CALL_TYPE || this.direction == Constants.OUTBOUND_POPUP) {
      this.unknownClient(Constants.OUTBOUND_CALL_ACCESS_MSG, submsg);

    }
    else {
      this.unknownClient(Constants.INBOUND_CALL_ACCESS_ERRORMSG, submsg);
    }
  }

  /**@author Vamsi
   * when user recieve unknown client call/chat
   */
  unknownClient(type,submsg?) {
   if(!submsg) this.rootScope.unauthorizedConversations.push(this.conversationId);
    this.rootScope.customerLink = 0;
    this.router.navigate(['/customer-search'], {
      skipLocationChange: true,
    });
    if (this.customerCmpt) 
      this.customerCmpt?.customerSearchForm?.get('clientName')?.disable();

    this.rootScope.openCustomDialog(
      type,
      'NA',
      submsg?Constants.buttonEnum.no:'',
      Constants.CUSTOMER_SEARCH,
      '',
      submsg?Constants.buttonEnum.yes:Constants.GOT_IT_BUTTON_TYPE,
      'inbound-modal',
      submsg
    );

  }

  /**@author Pooja
   * when user recieve SL1(CallBack) call
   */
  handleUnIdentifiedCallBackCall(GenesysRes?) {
    this.logService.infoLogs("Method handleUnIdentifiedCallBackCall called",this.className)
    this.openDuplicateCustSearchTab(Constants.unidentifiedCalls.Callback, GenesysRes);
  }

  /**@author Amarjeet
   * when user recieve SL1(UnIdentified) call
   */
  handleUnIdentifiedCall(GenesysRes?) {
    if (this.direction == Constants.OUTBOUND_POPUP){
      this.logService.infoLogs("ClientId Present but PPT unidentified .Hence its Outbound Unknown call", this.className)
      this.openDuplicateCustSearchTab(Constants.unidentifiedCalls.Outbound, GenesysRes)
    }
    else{
      this.logService.infoLogs("ClientId Present but PPT unidentified .Hence its Inbound Unknown call", this.className)
      this.openDuplicateCustSearchTab(Constants.unidentifiedCalls.UnknownCaller, GenesysRes);

    }
  }

  /**
   * created as per need of CCR3-1241
   * Below method opens the duplicate customer Search page in case of
   * froze the other opened account to be behaved as normal CA tab.
   * SL1 callback call
   * @param liveCall
   * @author :Pooja Gupta
   */
  openDuplicateCustSearchTab(tabTitle, GenesysRes?) {
    if(this.rootScope.isUnknownClientCall_PId){
      GenesysRes = this.rootScope.isUnknownClientCall_PId;
      this.timerService.startTimerAtCallLand(GenesysRes.clientValue?.connectedTime|| new Date().toISOString());
    }
    this.logService.infoLogs("ClientId Present but PPT unidentified .Hence its Unknown call with title = "+ tabTitle, this.className)
    if (!this.rootScope.customerTabs.find(x => x.conversationId == this.conversationId)) {
      // console.log('handleUnIdentifiedCall called', tabTitle);
      this.rootScope.unknownTab = null;
      let tabdt = new Tab();
      tabdt.showContent = true;
      tabdt.title = tabTitle;
      tabdt.id = 1;
      tabdt.active = true;
      tabdt.activeCall = this.rootScope.isLiveCall;
      tabdt.activeChat = this.rootScope.isLiveChat;
      if(this.rootScope.isLiveCall){
        tabdt.iconClass = 'red';
      }
      else 
        {
         tabdt.iconClass = 'solid red';
        }

      tabdt.closeIcon = false;
      tabdt.customerSessionId = this.conversationId;
      tabdt.clientId = this.liveClient;
      tabdt.conversationId = this.conversationId;
      tabdt.customerParticipantId = GenesysRes?.clientValue?.id;
      tabdt.tabData = { direction: this.direction, phoneNumber: this.rootScope.isLiveCall ? this.rootScope.removeTelPrefix(this.phoneNumber) : '', genesysRes: GenesysRes };
      tabdt.channel = this.rootScope.isLiveCall ? Constants.conversion.call : Constants.conversion.chat;
      //Condition add to hold SL1 call into holdLiveDetails and populate popup
      // Implemented for CCR1-2683
      if (!this.rootScope.checkMaxCustAccount()) {
        /**CCR3-3401
      * @author Vamsi.pamidala
      * to handle tba hide and show condiions 
      */
        this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.HIDE, this.rootScope.customerLink);

        this.rootScope.customerTabs.splice(1, 0, tabdt);
        this.rootScope.displayRedIcon = true;
        this.rootScope.customerLink = tabdt.customerSessionId;
        /**Below active Cust Tab added for handling the SL1 Unknown call CCR1-5017*/
        this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
          this.rootScope.customerTabs,
          'customerSessionId',
          this.rootScope.customerLink
        );
        this.router.navigate([`/customer-search-unidentified-call/${this.rootScope.customerLink}`], {
          skipLocationChange: true,
        });
        if (!(this.rootScope.isConference || this.rootScope.istransferred)) {
          //Updated For CCR3-4368
          this.handleOutboundCallDialingOrConnected();
          this.openRecordingDialPopUp();
        }

        if (this.rootScope.isConference)
          tabdt.lastInteractionStatus = Constants.isConference_CALL_TYPE
        else if (this.rootScope.istransferred)
          tabdt.lastInteractionStatus = Constants.Transferred_CALL_TYPE;


      } else {
        /* istanbul ignore next */
        if (this.rootScope.isLiveCall) this.rootScope.holdLiveDetails = []; // to handle the live call scenario
        /* adding below code for CCR1-7640*/
        /* istanbul ignore next */
        tabdt.id = '1';
        this.rootScope.holdLiveDetails.push(tabdt);
        //this.rootScope.holdLiveDetails[0].id = 1;
        /* adding below code for CCR1-7640*/
        this.routeToActiveTab(this.rootScope.activeCustTab?.customerSessionId || '0');
        this.showPopup();
      }
    }
  }

  /**
   *
   * @param data set person data
   * @returns selected customer details
   */

  setPersonDetails(data?) {
    let securityLevel;
    let selectedRowData = data ? data.row : null;
    this.personData = new personData();
    if (this.rootScope.isLiveCall) {
      securityLevel = this.tabSecurityDt(this.liveCall, data ? data.buttonName : null)?.SL || '0';
    }
    else if (this.rootScope.isLiveChat) {
      securityLevel = this.tabSecurityDt(this.liveChat, data ? data.buttonName : null)?.SL || '0';
    }
    else securityLevel = this.tabSecurityDt(null, data ? data.buttonName : null)?.SL || '0';

      /* istanbul ignore next */
    if (selectedRowData) {
      if (selectedRowData.clientId) this.personData.clientId = selectedRowData.clientId;
      else this.personData.clientId = this.customerCmpt?.customerSearchForm?.value?.clientId;
      this.personData.globalIdentifierId = selectedRowData.udpId;
      this.personData.customerType = selectedRowData.customerType;
      //this.personData.platformExternalId = data.platformExternalId;
    }
     else if (this.rootScope.isLiveCall) {
      this.parentData = null;
      this.personData.clientId = this.getClientId();

      if (this.liveCall?.UDP_GBL_ID) {
        this.personData.globalIdentifierId = this.liveCall?.UDP_GBL_ID;
        this.personData.platformExternalId = '';
      } else if (this.leavProCallValidation(true) && this.dynamicATT?.[1]) {
        this.personData[this.dynamicATT[0]] = this.dynamicATT[1];
      }
      else {
        this.personData.platformExternalId = this.getDecryptedValue();
      }

      //@amarjeet added logic for CCR3-12547   
    if (this.rootScope.identifyUserSubjectType(this.personData.clientId)) {
      let custId = this.rootScope.checkCallOrChat() ? this.getDecryptedValue() : selectedRowData.platformExternalId;
      if (custId) {
        this.personData.platformExternalId = custId;
         this.personData.globalIdentifierId ='';
      }
      else if(selectedRowData) {
        this.personData.platformExternalId = selectedRowData.platformExternalId;
        this.personData.globalIdentifierId ='';
      }
    }

    } else if (this.rootScope.isLiveChat) {
      this.parentData = null;
      this.personData.clientId = this.getChatClientId(this.liveChat[Constants.ALS_chat.ClientID]);//this.liveChat?.[Constants.ALS_chat.ClientID];
      this.personData.globalIdentifierId =
        this.liveChat?.[Constants.ALS_chat.PrsnId];
      if (!this.personData.globalIdentifierId && this.dynamicATT[1]) {
        this.personData[this.dynamicATT[0]] = this.dynamicATT[1];
      }

      //this.parentData.securityLevel = this.tabSecurityDt(this.liveCall || this.liveChat)?.SL;
    }

    this.personData.userSessionId = this.rootScope.sessionId
      ? this.rootScope.sessionId
      : 'abc123defgh';
    this.personData.customerSessionId = '';
    this.personData.serviceName = 'get-person-data';
    this.personData.urlPattern = '';
    this.personData.apiVersion = Constants.apiVersions;
    this.personData.componentName = 'PERSON-PID-DATA';
    this.personData.openAccountProcess = true;
    this.personData.domain = 'COMMON';
    this.personData.securityLevel = this.custAccService.updateScurityLevel(securityLevel);
    if (!this.rootScope.isLiveCall && !this.rootScope.isLiveChat) {
      this.personData.securityLevel = '0';
    }


    return this.personData;
  }
  /* istanbul ignore next */
  getClientId(clientId?: string): any {
    // Reset the previous clientId
    this.liveClient = null;

    if (this.liveCall?.QUEUE_NAME?.includes('_')) {
      const clientIds = this.liveCall?.QUEUE_NAME?.split('_');      
      if (this.clients?.find((x) => x.clientId === clientIds[0])) {
        if (!this.rootScope.Prod_lifeCycle) {
          clientIds[0] = this.replaceClientForTargetAlisAttribute(this.liveCall, clientIds[0]);
        }
        return this.clientEnableValidation(clientIds[0]);
      }
      else {
        this.liveClient = this.checkForClientSystemMapping(clientIds[0]);
        if (this.rootScope.isClientMapped) {
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveCall, this.liveClient);
          }
          return this.clientEnableValidation(this.liveClient);
        }
        else{
          
      /***Case of invalid clientId where valid clientId can be picked up 4m CS_CLIENT_ID value 
       * CCR1-9811 / @author :Pooja / Sample QUEUE_NAME = "xxxx_OFS".
        * 
      */

          
      let alisClientId, alisChatClientId;
      if (this.rootScope.isLiveCall && this.liveCall)
        alisClientId = this.liveCall?.CS_CLIENT_ID;

      else if (this.rootScope.isLiveChat)
        alisChatClientId = clientId || this.liveChat?.[Constants.ALS_chat.ClientID];

      if (alisClientId) {
        if (this.clients?.find(x => x.clientId == alisClientId)) {

          this.liveClient = alisClientId;
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveChat, this.liveClient);
          }
        }
        else {
          this.liveClient = this.checkForClientSystemMapping(alisClientId);
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveChat, this.liveClient);
          }
          if (!this.rootScope.isClientMapped) {
            console.log("client not found");
            this.logService.errorLogs("Conversation Id: "+this.conversationId +" Client not found for clientId = " + this.liveClient, this.className);
          }
          else if (this.clients?.find((x) => x.clientId === this.liveClient)) {
            return this.clientEnableValidation(this.liveClient);
          }
        }
      }
      else if (alisChatClientId) {
        if (this.clients?.find(x => x.clientId == alisChatClientId)) {
          this.liveClient = alisChatClientId;
        }
        else {
          this.liveClient = this.checkForClientSystemMapping(alisChatClientId);
          if (!this.rootScope.isClientMapped) {
            console.log("client not found");
            this.logService.errorLogs("Conversation Id: "+this.conversationId +" Client not found for clientId = " + this.liveClient, this.className);
          }
        }
      }


  }
      }
      // for enterprise client
      if (this.clients?.find((x) => x.clientId === clientIds[1])) {
        this.liveClient = clientIds[1];
        if (!this.rootScope.Prod_lifeCycle) {
          this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveCall, clientIds[1]);
        }
      }
      else {
        this.liveClient = this.checkForClientSystemMapping(clientIds[1]);
        if(this.liveClient === clientIds[1]){
          if(this.rootScope.isLiveCall){
            this.liveClient = this.liveCall?.CS_CLIENT_ID;
          }
          else if(this.rootScope.isLiveChat){
            this.liveClient = this.liveChat?.[Constants.ALS_chat.ClientID];
          }
        }
        if (this.rootScope.isClientMapped) {
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveCall, clientIds[1]);
          }
          return this.clientEnableValidation(this.liveClient);
        }
        else {
          console.log("client not found");
          this.logService.errorLogs("Conversation Id: "+this.conversationId +" Client not found for clientId = " + this.liveClient, this.className);
        }
      }
    }
    else {

      let alisClientId, alisChatClientId;

      if (this.rootScope.isLiveCall && this.liveCall)
        alisClientId = this.liveCall?.CS_CLIENT_ID;

      // else if (this.rootScope.isLiveChat && this.liveChat)
      //   alisChatClientId = clientId || this.liveChat?.[Constants.ALS_chat.ClientID];

      if (alisClientId) {
        if (this.clients?.find(x => x.clientId == alisClientId)) {

          this.liveClient = alisClientId;
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveChat, this.liveClient);
          }
        }
        else {

          this.liveClient = this.checkForClientSystemMapping(alisClientId);
          if (!this.rootScope.Prod_lifeCycle) {
            this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveChat, this.liveClient);
          }
          if (!this.rootScope.isClientMapped) {
            console.log("client not found");
            this.logService.errorLogs("Conversation Id: "+this.conversationId +" Client not found for clientId = " + this.liveClient, this.className);
          }
        }
      }
      else if (alisChatClientId) {
        if (this.clients?.find((x) => x.clientId === alisChatClientId)) {
          this.logService.debugLogs(
            "Client found for alisChatClientId =" +JSON.stringify(alisChatClientId),
            this.className
          );
          this.logService.debugLogs("Client list present =" +JSON.stringify(this.clients), this.className);
          this.liveClient = alisChatClientId;
        }
        else {
          this.liveClient = this.checkForClientSystemMapping(alisChatClientId);
          if (!this.rootScope.isClientMapped) {
            console.log("client not found");
            this.logService.errorLogs("Conversation Id: "+this.conversationId +" Client not found for clientId = " + this.liveClient, this.className);
          }
        }
      }
    }
    if (!this.rootScope.Prod_lifeCycle) {
      this.liveClient = this.replaceClientForTargetAlisAttribute(this.liveCall ? this.liveCall : this.liveChat, this.liveClient); 
    }
    return this.clientEnableValidation(this.liveClient);
  }

  /**
   * Retrieves the chat client ID based on the provided live chat attributes and client ID.
   * 
   * @param liveChatAttribute - An attribute indicating whether live chat is enabled.
   * @param alisChatClientId - The client ID associated with the live chat session.
   * @returns A boolean indicating whether the client is enabled after validation.
   * 
   * @remarks
   * - If live chat is active and the `liveChatAttribute` is provided, the method checks if the client exists in the list of clients.
   * - If the client is found, it logs debug information and sets the `liveClient` to the provided `alisChatClientId`.
   * - If the client is not found, it attempts to map the client using `checkForClientSystemMapping` and logs an error if the client is not mapped.
   * - If live chat is not active, it logs the current list of clients.
   * 
   * @example
   * ```typescript
   * const isClientEnabled = service.getChatClientId(true, 'client123');
   * console.log(isClientEnabled); // Output: true or false based on validation
   * ```
   * //@author Vamsi.pamidala
   * CCR3-11668
   */
  getChatClientId(alisChatClientId) {
    try {
      if (this.rootScope.isLiveChat && alisChatClientId) {
        if (this.clients?.find((x) => x.clientId === alisChatClientId)) {
          this.logService.errorLogs(
            "Client found for alisChatClientId =" + JSON.stringify(alisChatClientId),
            this.className
          );
          
          this.liveClient = alisChatClientId;

        }
        else {
          this.liveClient = this.checkForClientSystemMapping(alisChatClientId);
          
          if (!this.rootScope.isClientMapped) {
           
            this.logService.errorLogs("Conversation Id: " + this.conversationId + " Client not found for clientId = " + this.liveClient, this.className);
          }

        }
        return this.clientEnableValidation(this.liveClient);
      }
      else {
        this.logService.errorLogs("Client list present =" + JSON.stringify(alisChatClientId), this.className);
      }
    }
    catch (error) {
      this.logService.errorLogs("Error in getChatClientId method: ", this.className);
    }
  }

  /*
  Hardcoding done to replace premier client . Only applicable for lower lifecycle
  */
  replaceClientForTargetAlisAttribute(liveAttribute: any, liveClient: any) {
    if (liveClient == Constants.PREMIER_CLIENT_ID && liveAttribute?.['TargetSystem'] == 'LP') {
      return Constants.PREMIER_TEST_CLIENT_ID;
    }
    return liveClient;
  }
  /**
  * 
  * @param clientId 
  * Below method to validate screen pop payload enable or disable 
  * @returns true/false to confirm live call/chat will land in care portal 
  */
  clientEnableValidation(clientId) {
    if (this.rootScope.screenPopCheck(clientId)) {
      this.rootScope.isScreenpopAttributeEnabled = true;
      this.liveClient = clientId;
      return this.liveClient;
    }
    else {
      this.rootScope.isScreenpopAttributeEnabled = false;
      return this.liveClient = null;
    }
  }

  checkForClientSystemMapping(alisClientId) {
    this.rootScope.isClientMapped = false;
    for (const record of this.rootScope?.clientSystemIds) {
      if (record.data !== null) {
        for (const key in record.data) {
          if (record.data.hasOwnProperty(key)) {
            const dataItem = record.data[key];
            if (dataItem && dataItem?.systemName == Constants.CLIENT_SYSTEM_MAPPING_TELEPHONY
              && dataItem?.targetSystemAttributeName == Constants.CLIENT_SYSTEM_MAPPING_CLIENT
              && dataItem?.targetSystemAttributeValue == alisClientId
            ) {
              this.rootScope.isClientMapped = true;
              return dataItem?.clientId;
            }
          }
        }
      }
    }
    //  })
    return alisClientId;
  }

  /**
     * Method to to check client id mapping during interaction disconnected if exist mapping then replace client id
     * @param cpClientId = care portal sytem client id
     * @author :Amarjeet
     */
  checkClientSystemMappingAndReplace(cpClientId) {
    for (const record of this.rootScope?.clientSystemIds) {
      if (record.data !== null) {
        for (const key in record.data) {
          if (record.data.hasOwnProperty(key)) {
            const dataItem = record.data[key];
            if (dataItem && dataItem?.systemName == Constants.CLIENT_SYSTEM_MAPPING_IH
              && dataItem?.targetSystemAttributeName == Constants.CLIENT_SYSTEM_MAPPING_CLIENT
              && dataItem?.clientId == cpClientId
            ) {
              return dataItem?.targetSystemAttributeValue;
            }
          }
        }
      }
    }
    return cpClientId;
  }


  /**confirm chat client single or multiple */

  setChatClient() {
    return this.rootScope.liveChatCTS?.length == 1
      ? this.rootScope.liveChatCTS[0]?.clientId
      : this.liveChat[Constants.ALS_chat.ClientID];
  }

  /**confirm chat unknown client single or multiple */
  setUnknownTabClient() {
    let clientId = this.rootScope.customerTabs?.find(x => x.id == '1')?.clientId;
    return clientId ? clientId : this.rootScope.liveChatCTS[this.rootScope.liveChatCTS?.length - 1]?.clientId;
  }

  capitalizeFirstLetter(str) {
    return '0' + str.slice(1);
  }

  getDecryptedValue() {
    //console.log('this.liveCall', this.liveCall);
    if (this.liveCall?.IS_CS_CUSTOMER_ID_ENCRYPTED) {
      return this.encryptDecryptService.decodeAndDecrypt(
        this.liveCall?.ENC_CS_CUSTOMER_ID
      );
    } else return this.liveCall?.ENC_CS_CUSTOMER_ID;
  }

  /*end gensys */
  accessComponent(self) {
    this.customerCmpt = self;
  }
  /**
   * @param
   data is for open reserach customer  
   * GenesysRes = 
   * @param self  added for CCR1-7167 to clear customer search form only when customer account opened *
   */
  getPersonDataAPI(data?, GenesysRes?, self?) {
    /* Below condition in getPersonData method is to show progress indicator on the interaction status card
      when the user on same Customer Account from where he has initiated an outbound call and the call gets connect
       or the user has received an inbound call on the same account */
    //let liveDetail = clientValue?.attributes;
    try {

    let personDataObj = this.setPersonDetails(data ? data : null);


    if (personDataObj.globalIdentifierId == this.rootScope.activeCustTab.id) {
      /* istanbul ignore next */
      this.rootScope.custAccInteractionLoaderTimeoutId = setTimeout(() => {
        this.rootScope.showCustAccInteractionLoaderMsg = true;
      }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);
      this.rootScope.custAccInteractionLoader = true;
    }
     /* istanbul ignore next */
    this.rootScope.custSearchLoaderTimeoutId = setTimeout(() => {
      this.rootScope.showCustSearchLoaderMsg = true;
    }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);

    this.apiService
      .postApi(
        Global.openAccountApi.getPersonData,
        personDataObj,
        'false',
        Constants.apiVersions,
        false
      )
      .subscribe({
        next: (res) => {
          
          clearTimeout(this.rootScope.custAccInteractionLoaderTimeoutId);
          this.rootScope.custAccInteractionLoader = false;
          this.rootScope.showCustAccInteractionLoaderMsg = false;
          clearTimeout(this.rootScope.custSearchLoaderTimeoutId);
          this.rootScope.custSearchLoader = false;
          this.rootScope.showCustSearchLoaderMsg = false;

          /* istanbul ignore next */
          if (res && res?.data?.firstName) {
            res = this.apiService.errorValidation(res);
            res.clientId = personDataObj.clientId;
            // res.platformExternalId = personDataObj.platformExternalId;
            res.customerType = personDataObj.customerType;


            if (data)
              data.defaultRole = res?.data?.defaultRole;

            res.conversationId = GenesysRes ? GenesysRes?.conversationId : null;//Live conversationId will update in customer tab data;
            if (GenesysRes && this.leaveProvalidation()) {
              this.updateALSAttribute(GenesysRes, res.globalPersonIdentifier);
            }
            /**
             * @author Vamsi krishna
             * CCR3-6624 to handle CS pro transfer calls 
             */
            if (this.rootScope.isLiveCall && GenesysRes) {
              this.updateCSProPayloads(GenesysRes, res);//CCR3-7385
            }
            else if (GenesysRes && this.rootScope.isLiveChat) {
              this.updatePPT_NAME(GenesysRes, res);

            }

            this.rootScope.activeCustTab
            // console.log("GenesysRes?.clientValue",GenesysRes?.liveUser)
            if (this.rootScope.isLiveChat)
              this.timerService.startTimerAtChatLand(res['customer-session-id'], GenesysRes?.liveUser?.connectedTime);

            console.log("res", res)
            
            this.openCustomerAccount(res, GenesysRes?.clientValue, data?.buttonName);
            if (self) this.customerCmpt.clearAll();

          } 
          else if (GenesysRes) {//UDP id not available in data base it will route to customer search page 
            this.invalidUDPID(GenesysRes);

          } else {
            this.rootScope.enableAlerts(Constants.ERROR, AlertMsg.udpError);
            this.rootScope.customerLink = 0;
            this.router.navigate(['/customer-search'], {
              skipLocationChange: true,
            });

          }
        },
        error: (err) => {
          /* istanbul ignore next */
          if (err) {
            clearTimeout(this.rootScope.custAccInteractionLoaderTimeoutId);
            this.rootScope.custAccInteractionLoader = false;
            this.rootScope.showCustAccInteractionLoaderMsg = false;
            clearTimeout(this.rootScope.custSearchLoaderTimeoutId);
            this.rootScope.custSearchLoader = false;
            this.rootScope.showCustSearchLoaderMsg = false;

            /**  Added as a part of CCR1-10945  / Use case where udpId is not mapped with provided clientId in UDP ****/
            let msg = Constants.API_FAILURE_RESP_MSG['default'];
            if(err?.error?.errorResponse?.message == Constants.PARTICIPANT_CLIENTID_MISMATCH_ERRMSG && this.rootScope.isLiveCall){
              msg = Constants.API_FAILURE_RESP_MSG[err?.error?.errorResponse?.message]
            }
            this.rootScope.enableAlerts(Constants.WARNING, msg);
            this.rootScope.customerLink = 0;
            this.router.navigate(['/customer-search'], {
              skipLocationChange: true,
            });
            
          }
        },
      });
    } catch (error) {
      /* istanbul ignore next */
      this.logService.errorLogs("Error in getPersonDataAPI method", this.className);
    }
  }

  /**
   * Retrieves person data based on the provided parameters.
   * 
   * @param data - Optional parameter containing data to be used in the API call.
   * @param GenesysRes - Optional parameter containing Genesys response data.
   * @param self - Optional parameter representing the context or instance of the calling object.
   * 
   * If the application is in a live call state and Genesys response data is available,
   * it validates the line of business using the Genesys response data. Otherwise,
   * it calls the getPersonDataAPI method with the provided parameters.
   */
  getPersonData(data?, GenesysRes?, self?) {

    if (this.rootScope.isLiveCall && GenesysRes && (this.liveCall?.CP_INDICATIVE_DATA_SECURED == "true" || this.liveCall?.['CS_AUTH_CD']?.includes(Constants.AuthMenu.UAS)) && this.liveCall?.Config_DesktopIndicator) {
      this.validateLineofBusiness(GenesysRes);
    }
    else {
      let timer = 0;
      if (this.rootScope.isLiveCall && !this.rootScope.clientPropDataMap.has(this.liveClient)) {
        this.custAccService.getClientInfoCardData(this.liveClient, false, this);
        timer = 1000;
      }
      setTimeout(() => {
        this.getPersonDataAPI(data, GenesysRes, self);
      }, timer);
    }

  }

  /**
   * 
   * @param GenesysRes 
   * Route to  duplicate customer search page if UDP Id is not available in existing env database.
   */
  invalidUDPID(GenesysRes) {
    this.rootScope.isGensysUDPErrorToHide = false;
    this.rootScope.errorMsg = Constants.GENSYS_CONS[402] + AlertMsg.udpError;
    if (this.rootScope.isLiveChat) {
      // this.rootScope.enableAlerts(Constants.ERROR, Constants.GENSYS_CONS[402] + AlertMsg.udpError);
      this.openDuplicateCustSearchTab(Constants.unidentifiedCalls.UnknownCaller, GenesysRes)
    }
    else if (this.rootScope.isCallBackCall) {

      this.handleUnIdentifiedCallBackCall(GenesysRes);
    } else {
      if (this.liveCall?.ENC_CS_CUSTOMER_ID) this.liveCall.ENC_CS_CUSTOMER_ID = null;
      this.handleUnIdentifiedCall(GenesysRes);
    }
  }

  openNewCustomerTab(tab, buttonName) {
    this.handleSL1CalBackTabCloseOnAcntOpen(tab);

    try {
      if (
        this.rootScope.customerTabs.find(
          (x) => (x.CS_SECURITY_LEVEL == Constants.securityLevels.SL1 || x.CS_SECURITY_LEVEL == Constants.securityLevels.SL2) && (x.activeCall || x.activeChat)
        ) &&
        buttonName == Constants.buttonEnum.replaceAccount
      ) {
        this.replaceAccountProcess(tab);//Replace account handling in new function

      } else {
        let index;
        if (!tab.additionalAccount && tab.activeCall) {
          let clonedTab = Object.assign({}, tab)
          try {
            this.timerService.updateTimerMapWithCustomerSessionId(tab.customerSessionId);
          } catch (e) {
            /* istanbul ignore next */
            console.log("Error in method updateTimerMapWithCustomerSessionId ", e)

          }
        }

        if (tab.parentId)
          index = this.rootScope.customerTabs.findIndex(
            (x) =>
              x.id == tab.parentId && x.conversationId == tab.conversationId
          );

        if (tab.parentId && index != this.rootScope.customerTabs?.length) { this.rootScope.customerTabs.splice(index + 1, 0, tab); }
        else this.rootScope.customerTabs.push(tab);
      }
      /**CCR3-3401
       * @author Vamsi.pamidala
       * to handle tba hide and show condiions 
       */

      if (tab.customerSessionId != this.rootScope.activeCustTab?.customerSessionId) {
        this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.HIDE, this.rootScope.activeCustTab?.customerSessionId);
      }
      this.rootScope.customerLink = tab.customerSessionId;
      if (!this.rootScope.checkCallOrChat()) {
        this.updateIdle(tab, this.rootScope.CCTConfigs.TIME_THRESHOLD);
      }

      this.updateActiveTabDetails(this.rootScope.customerLink);
      this.custAccService.openNewCustAcc(tab);
       if (!buttonName && this.rootScope.isCallBackCall && !this.rootScope.isConference && !this.rootScope.istransferred && !tab.additionalAccount) {
        this.handleOutboundCallDialingOrConnected();
        this.openRecordingDialPopUp();
      }
      // link additional account
    } catch (error) {
      //this.logService.log(error);
    }
  }

  /**
   * @author VamsiKrishna
   * @param tab selected for replacing live call account
   * Handling replacing customer account all SL1 calls(inbound/outbound/callback)
   */
  replaceAccountProcess(tab) {
    this.rootScope.deliveryOption = '';
    let index = this.rootScope.customerTabs.findIndex(
      (x1) => (x1.CS_SECURITY_LEVEL == Constants.securityLevels.SL1 || x1.CS_SECURITY_LEVEL == Constants.securityLevels.SL2) && (x1.activeCall || x1.activeChat)
    );
    if (!tab.activeChat) tab.activeCall = true;
    // console.log('tab-------------', tab);
    if (this.rootScope.customerTabs[index]) {
      this.rootScope.closeKCWindow(this.rootScope.customerTabs[index]);
      this.rootScope.closeExternalTabs(this.rootScope.customerTabs[index]);
      let previousTab = this.rootScope.customerTabs[index];
      tab.CS_SECURITY_LEVEL = previousTab.CS_SECURITY_LEVEL;
      tab.conversationId = previousTab.conversationId;
      tab.customerParticipantId = previousTab.customerParticipantId;
      tab.additionalAccount = false;
      tab.closeIcon = previousTab.closeIcon;
      tab.iconClass = previousTab.iconClass;
      tab.Config_DesktopIndicator = previousTab.Config_DesktopIndicator;
      tab.tabData = {
        tabData: tab?.tabData?.tabData,
        liveDetail: previousTab.tabData?.liveDetail,
        direction: previousTab.tabData?.direction,
        phoneNumber: previousTab.tabData?.phoneNumber,
      };
      tab.authenticateStatus =
        this.rootScope.customerTabs[index].authenticateStatus;
      tab.startSL = this.rootScope.customerTabs[index].authenticateStatus;
      //  setTimeout(() => {
      // that.genesysCloudService.updateSL1CallAttributes(data, this.customerSearchForm?.value?.customerType);
      try {


        if (this.rootScope.isLiveCall) {
          let externalId = tab?.tabData?.tabData?.platformExternalId;
          this.customerCmpt.genesysCloudService.updateSL1CallAttributes({
            row:
              { udpId: tab.id, clientId: tab.clientId, platformExternalId: externalId?.length > 12 ? this.encryptDecryptService.decrypt(externalId) : externalId }
          }, tab.customerType);
          this.rootScope.patchGENAttribute.next({
            conversationId: tab.conversationId,
            participantId: tab.customerParticipantId,
            body: {
              attributes: {
                "PPT-NAME": tab.tabData?.tabData?.firstName + ' ' + tab.tabData?.tabData?.lastName,
                EMP: tab.tabData?.tabData?.employmentStatusCode,
              }
            }
          })
          if (this.rootScope.simulationData?.isSimulationModeActive) {
            this.rootScope.simulationRecords?.forEach((x: any) => {
              if (x.conversationId == tab.conversationId) {
                x.fullName = tab.title;
              }
            });
          }
        }
        else if (this.rootScope.isLiveChat) {
          this.rootScope.patchGENAttribute.next({
            conversationId: tab.conversationId,
            participantId: tab.customerParticipantId,
            body: {
              attributes: {
                'context.glblPrsnId': tab.id,
                PINV: Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
                "PPT-NAME": tab.tabData?.tabData?.firstName + ' ' + tab.tabData?.tabData?.lastName,
                EMP: tab.tabData?.tabData?.employmentStatusCode,
              }
            }
          })
        }

      } catch (error) {
        this.logService.errorLogs("Error in replaceAccountProcess method", this.className);
      }
      // }, 1000)
        /* istanbul ignore next */
      this.deleteCustomerInElasticCache(previousTab.customerSessionId);
      /* istanbul ignore next */
      this.updateTimerEntryForPreviousTab(previousTab.customerSessionId, tab.customerSessionId)
      // Close TBA screens related to customer
        /* istanbul ignore next */
      this.closeCustomerTbaScreens(previousTab);
      // Close TBA screens related to customer
    }
    this.intHistService.deleteEntryIHMap(tab.customerSessionId);
    this.custAlertsService.deleteEntryCustAlertMap(tab.customerSessionId);
    this.intHistService.transferredDataArr = [];
    this.rootScope.customerTabs.splice(index, 1, tab);
  }


  /**
  * CCR3-7670
  * Handles ALS attribute updates by integrating active tab conversation details,
  * wrap-up topics, PII, and employment-specific data dynamically.
  * @author :Hashid 
  */
  upadateALSAttributeInWrapUp(wrapUpPmtData) {
    try {
      let activeTab = this.rootScope.activeCustTab;
      this.rootScope.patchGENAttribute.next({
        conversationId: activeTab?.conversationId, participantId: activeTab?.customerParticipantId,
        body: {
          attributes: {
           // "PPT-NAME": activeTab.tabData?.tabData?.firstName + " " + activeTab.tabData?.tabData?.lastName,
            PII: activeTab.tabData?.tabData?.platformInternalId,
            //EMP: activeTab.tabData?.tabData?.employmentStatusCode,
            PST: wrapUpPmtData?.wrapUpPstData,
            PMT: wrapUpPmtData?.wrapUpPmtData,
            CTP: activeTab?.customerType
          }
        }
      })
    }
    catch (error) {
      console.log("Error in updateALSAttribute:", error)
    }
  }

  /**
   * Below method update timerMap's entry of previousTab customerSessionId with new one .
   * As as per req , we have to continue  timer for replaced account
   * @param previousTabCustomerSessionId
   * @param replacedTabCustomerSessionId 
   */

  updateTimerEntryForPreviousTab(previousTabCustomerSessionId, replacedTabCustomerSessionId) {
    this.timerService.continueTimerForReplace(this.timerService.timerMap[previousTabCustomerSessionId], replacedTabCustomerSessionId);
  }

  /**
   * Below method closes duplicate CS tab on CA opening
   * for callback call
   */
  handleSL1CalBackTabCloseOnAcntOpen(tab) {
    if (
      (this.rootScope.isCallBackCall || !this.liveCall?.ENC_CS_CUSTOMER_ID) &&
      this.rootScope.isDuplicateCustSearchTabOpened && tab?.conversationId == this.rootScope.activeCustTab?.conversationId
    ) {
      // setTimeout(()=>{
      this.rootScope.isDuplicateCustSearchTabOpened = false; this.rootScope.unknownTab = null;
      this.rootScope.customerTabs = this.rootScope.customerTabs.filter(x => !(x?.id == 1 && (x?.conversationId == this.rootScope.conversationId || x?.conversationId == this.rootScope.activeCustTab.conversationId)));

      // },100)
    }
  }



  createNewTabDTO(res, clientValue) {

    let liveDetail = clientValue?.attributes;
    // console.log('ConversationId', this.rootScope.conversationId + this.conversationId);

    let tabdt = new Tab();
    tabdt.showContent = true;
    try {
      let liveStatus = this.rootScope.checkCallOrChat();

      let additionalAccount = liveDetail
        ? false
        : this.rootScope.activeChatOrCall() == 0 || liveStatus
          ? false
          : true;

      let securityLevelDt = this.tabSecurityDt(liveDetail);

      tabdt.id = res.globalPersonIdentifier;
      tabdt.title = res.lastName + ', ' + res.firstName;

   
      tabdt.preferredName = res?.preferredName; // CCR1-10823
      //tabdt.sectorName = res?.sector; // CCR1-10823
      tabdt.tabData = {
        tabData: res,
        liveDetail: liveDetail,
        direction: liveStatus ? this.direction : '',
        phoneNumber: this.phoneNumber,
      };
      tabdt.activeCall = this.rootScope.isLiveCall ? true : false;
      tabdt.activeChat = (this.rootScope.isLiveChat && !this.rootScope.isLiveCall) ? true : false;
      tabdt.active = true;
      tabdt.iconClass = securityLevelDt.iconClr;
      tabdt.customerSessionId = res['customer-session-id'];
      tabdt.clientId = res.clientId;

      tabdt.additionalAccount = liveDetail
        ? false
        : this.rootScope.activeChatOrCall() == 0
          ? false
          : true;

      tabdt.closeIcon =
        liveDetail || this.rootScope.validationClsIcon() ? false : true;
      tabdt.idle = false;
      tabdt.isWrapupDone = false;
      tabdt.CS_SECURITY_LEVEL = additionalAccount ? '0' : securityLevelDt.SL;
      tabdt.authenticateStatus = additionalAccount
        ? Constants.Not_Applicable
        : securityLevelDt.authenticateStatus;
      tabdt.parentId = this.parentData?.id;
      tabdt.conversationId = additionalAccount
        ? 'NA'
        : (res.conversationId || (this.rootScope.conversationId && !this.rootScope.unauthorizedConversations?.includes(this.rootScope.conversationId) 
        ? this.rootScope.conversationId 
        : ""));

      tabdt.startTime = new Date();
      tabdt.endTime = new Date();
      tabdt.isChatTransferred = this.checkIsChatTransferred(liveDetail);
      if (!tabdt.customerParticipantId)
        tabdt.customerParticipantId = clientValue?.id ? clientValue?.id : 'NA';
      tabdt.customerType = this.getCustomerType(liveDetail, res);
      tabdt.defaultRole = this.getRoleType(liveDetail, res);
      tabdt.startSL = securityLevelDt.authenticateStatus;
      tabdt.externalLeaveId = this.rootScope.getValueFromALISAttributes(liveDetail, res?.clientId, Constants.AUTO_LAUNCH_EXTERNALLEAVEID_KEYNAME_CLIENTMAP);
      /**PersonId is the employeeId coming frome genesy */
      tabdt.personId = this.rootScope.getValueFromALISAttributes(liveDetail, res?.clientId, Constants.AUTO_LAUNCH_EEID_KEYNAME_CLIENTMAP);
      tabdt.employeeId = res?.employeeId ? res?.employeeId : 'NA';
      tabdt.genesysAttributes.cimData = this.updateCIM_DATA(liveDetail);//CCR3-4520;
      tabdt.cimData = tabdt.genesysAttributes.cimData;//CCR3-4520;
      this.updateAttributes(liveDetail, tabdt);
      tabdt.employmentStatusCode = res?.employmentStatusCode;
      tabdt.primaryLanguage = this.rootScope.getPrimaryLanguage(res);
      tabdt.last4DigitsOfSSN = res?.last4DigitsOfSSN;
      tabdt.isVIP = res?.isVIP;
      
      // CCR1-14992: Persistent Info Changes
      /**
       * Normalize and sort persistent info based on received sequence.
       * This ensures that the persistent info items are displayed in the correct order as determined by the backend.
       * elementLabel and elementValue are normalized to ensure consistent access regardless of backend naming conventions.
       */
      const persistentInfo = Array.isArray(res?.persistentInfo) ? res.persistentInfo : [];
      const normalizedPersistentInfo = persistentInfo.map((item: any) => ({
        elementLabel: item?.elementLabel ?? item?.element_label ?? '',
        elementValue: item?.elementValue ?? item?.element_value ?? '',
        sequence: item?.sequence ?? 0,
        title: item?.title ?? '',
        helperAttributes: item?.helperAttributes ?? item?.helper_attributes ?? ''
      }))
        .sort((a, b) => Number(a?.sequence) - Number(b?.sequence));
      // CCR1-14992 the dynamicItems array captures all persistentInfo items marked with the dynamic helper_attributes flag.
      const dynamicItems = normalizedPersistentInfo?.filter(
        item => String(item.helperAttributes)?.trim()?.toLowerCase() === Constants.PERSISTENT_INFO_HELPER_ATTRIBUTE.toLowerCase()
      ) ?? [];
      // CCR1-14992: Populate Age and Sector/Department tab fields from persistentInfo —
      tabdt.persistentInfo = normalizedPersistentInfo;
      tabdt.clientSpecificDynamicFields = dynamicItems;
      tabdt.preferredLocale = this.rootScope.getPreferredLocale(res);
      tabdt.telephonyId = this.rootScope.checkCallOrChat() ? localStorage.getItem(Constants.TELEPHONY_ID) || '' : 'N/A';
      tabdt.pronouns = res?.pronouns;
      tabdt.displayErrorDomainMsg = this.displayErrorDomainMsg(res,tabdt);
      tabdt.clearIdentityData.retryAttempts = this.rootScope.CCTConfigs.RETRY_ATTEMPTS;
      tabdt.clearFraudIdentityData.retryAttempts = this.rootScope.CCTConfigs.RETRY_ATTEMPTS;
      // if (this.rootScope.isLiveCall && !tabdt.additionalAccount && liveDetail?.CP_INDICATIVE_DATA_SECURED) {
      //   tabdt.CP_INDICATIVE_DATA_SECURED = liveDetail?.CP_INDICATIVE_DATA_SECURED;
      // }

      if (this.rootScope.isLiveCall && liveDetail) {
        tabdt.Config_DesktopIndicator = liveDetail?.Config_DesktopIndicator;
        
        if (this.rootScope.isConference || this.rootScope.istransferred) {
          tabdt.wrapUpData.interactionMode = "Transferred";
          tabdt.lastInteractionStatus = this.rootScope.isConference ? Constants.isConference_CALL_TYPE : Constants.Transferred_CALL_TYPE;
        } else {
          tabdt.wrapUpData.interactionMode = (this.direction === Constants.OUTBOUND_POPUP) ? "Outbound" : "Inbound";
        }
      } else if (this.rootScope.isLiveChat) {
        tabdt.wrapUpData.interactionMode = tabdt.isChatTransferred ? "Transferred" : "Inbound";
        tabdt.webMessage = (clientValue?.type == Constants.WEBMSG ? true : false);//CCR3-8214
        
      }

      if (this.rootScope.callFromSL1Tab) {
        additionalAccount = false;
        tabdt.additionalAccount = false;
        tabdt.closeIcon = false;
        this.rootScope.callFromSL1Tab = false;
      }

      this.identifyChannel(tabdt);
      if (this.parentData?.id) {
        tabdt.reasonForAdditional = this.reasonForAdditional;
        tabdt.conversationId = this.parentData?.conversationId;
        tabdt.tabData = {
          tabData: res,
          parentData: this.parentData,
          direction: this.parentData?.tabData?.direction,
        };
        tabdt.isAdditionalAccOpen = this.rootScope.isLiveChat
          ? Constants.conversion.chat
          : Constants.conversion.call;
        this.updateParentTab(tabdt.id);
      }
//CCR3-13170 Handling Multiple Account Tab
      if (tabdt.conversationId && !tabdt.additionalAccount && this.rootScope.multiAccountsMap.get(tabdt.conversationId)?.includes(tabdt.id)) {
        tabdt.isMultipleAccountTabOpened = true;
        this.rootScope.interactionsMap.forEach((Value, Key) => {
          if (Value?.externalRefId == tabdt.conversationId) {
            tabdt.multiAccountRecord.push({
              accountName: Value.contact.name,
              startTime: Value.begin,
              endTime: Value.end,
              udpId:Value.contact.id,
            });
          }
        });

        tabdt.multiAccountRecord.push({
          accountName: tabdt.title,
          startTime: new Date().toISOString(),
          endTime: new Date().toISOString(),
          udpId: tabdt.id,
        });
      }


    }
    catch (error) {
      console.log(error);
      //this.logService.error(error);
    }

    return tabdt;
  }

  /**CCR1-10523 */
  displayErrorDomainMsg(res: any, tabdt: Tab): boolean {
      if(res?.hasOwnProperty('errorDomains') && res?.errorDomains != null ){
        tabdt.errorDomains = res.errorDomains;
        return true;
      }
      else{
        tabdt.errorDomains = 'NA';
        return false;
      }
  }

  /**
   * 
   * @param data  live call participant attribute value
   * @param return cimdata like "DOB|ZIPCODE" 
   */
  updateCIM_DATA(data) {
      /* istanbul ignore next */
    if (data?.[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA] && this.rootScope.isLiveCall) {
      let cimdata = "";
      let ALS_CIM_DATA = JSON.parse(data[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA])?.['identifiers'];

      this.rootScope.cimData_config?.forEach(x => {
        if (ALS_CIM_DATA.includes(x?.['fieldValue'])) {
          cimdata += x['fieldValueDescription'] + "|";
        }
      })
      return cimdata || 'N/A';
    }
    else return "N/A";
  }




  updateAttributes(data, tab) {
    if (data && this.rootScope.isLiveCall) {

      /* istanbul ignore next */
      Object.keys(new GEN_attributes()).forEach(x => {
        if (data?.[x]) {
          //CCR3-9160
          if (x == 'CS_AUTH_CD' && data?.['CS_AUTH_CD']?.includes(Constants.AuthMenu.UAS)) {
            tab.genesysAttributes[x] = Constants.AuthMenu.IND_DATA;
            tab.genesysAttributes.CP_INDICATIVE_DATA_SECURED = true;
          } 
          else if (data[x] == "true") {
            tab.genesysAttributes[x] = true;
          }
          else if (x == 'CS_AUTH_CD' && tab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4 && this.rootScope.isCallBackCall) {
            tab.genesysAttributes[x] = "";
          }
          else
            tab.genesysAttributes[x] = data?.[x];

        }
        else if (x == "CS_AUTH_CD" && tab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
          // tab.genesysAttributes[x] = Constants.AuthCode.EA;
          //CCR3-10820
          this.handleAuthCode(tab, x, data);
        }
        else if (x == "cimData" && data?.['Config_DesktopIndicator'] == Constants.ALS_Config_DesktopIndicator && tab.CS_SECURITY_LEVEL == Constants.securityLevels.SL2 && (tab.genesysAttributes.cimData == "N/A" || !tab.genesysAttributes.cimData)) {
          let ALSCimdata = '';
          tab.genesysAttributes['Config_DesktopIndicator'] = data?.['Config_DesktopIndicator'];
          Object.keys(Constants.IVR_CON).forEach(x => {
            if (data[x]) {
              ALSCimdata = ALSCimdata + Constants.IVR_Fields[x];
            }
          });

          if (this.rootScope.callAttributes?.['cimData-fullEEID'] && data[this.rootScope.callAttributes?.['cimData-fullEEID']]) {
            ALSCimdata = ALSCimdata + Constants.conversationConfig.FULLEEID;
          }
          tab.genesysAttributes.cimData = ALSCimdata;
          tab.cimData = ALSCimdata;
        }

      })
    }
    else {
      let genesysAttributes = new GEN_attributes();
      if (this.rootScope.isLiveCall && this.liveCall) 
        genesysAttributes.QUEUE_NAME = this.liveCall['QUEUE_NAME'];
      else if(this.rootScope.isLiveChat){
        genesysAttributes.QUEUE_NAME = this.liveChat['QUEUE_NAME'];;
      }

      tab.genesysAttributes = genesysAttributes;
      this.logService.debugLogs("Method UpdateAttributes called genesysAttributes"+JSON.stringify(genesysAttributes),this.className)
    }
  }
  /**Below method check the CUSTOMER_TYPE value in Customer Participant Attribute of Genesys chat event 
   * and return that value which is implemented in createNewTabDTO() method */
  getCustomerType(liveDetail, res) {
    if (liveDetail && liveDetail?.CUSTOMER_TYPE) {
      return liveDetail?.CUSTOMER_TYPE;
    }
    else if (liveDetail && liveDetail?.CS_CALLER_TYPE) {
      //added to transfer call from CSPro to Care Portal
      let callerType = this.rootScope.customerTypeData.find(x => x.fieldValue == liveDetail?.CS_CALLER_TYPE)
      if (callerType)
        return liveDetail?.CS_CALLER_TYPE;
      else
        return Constants.defaultCaller;
    } else {
      return res?.customerType ? res.customerType : Constants.defaultCaller;
    }
  }

  getRoleType(liveDetail, res) {
    if (liveDetail && liveDetail?.ROLE_TYPE) {
      return liveDetail?.ROLE_TYPE;
    } else {
      return res?.defaultRole ? res.defaultRole : 'NA';
    }
  }

  

  /**Below method check the the Account which we are going to open is the Additional Account or not . If it is an
   * Additional Acccount it check the parent data contain the boolean value of isChatTransferred variable and return it
   * and in case of Customer Account it check the boolean of isChatTransferred variable which is added in liveDetail from
   * genesysChat() method of Genesys Cloud Service when it is a transferred chat and return it.*/
  checkIsChatTransferred(liveDetail) {
    const isAdditionalAcc = liveDetail
      ? false
      : this.rootScope.activeChatOrCall() == 0
        ? false
        : true;

    return isAdditionalAcc
      ? this.parentData?.isChatTransferred ?? false
      : liveDetail?.isChatTransferred ?? false;
  }

  getParentData(parentid) {
    this.parentData = this.rootScope.customerTabs.find((x) => x.id == parentid);
  }

  /*
  Identify the channel */
  identifyChannel(tabdt) {
    switch (true) {
      case this.rootScope.isLiveCall:
        tabdt.channel = Constants.IH_CALL;

        break;
      case this.rootScope.isLiveChat:
        tabdt.channel = Constants.IH_CHAT;
        break;

      default:
        tabdt.channel = Constants.conversion.research;
        break;
    }
  }

  updateActiveTabDetails(id) {
    this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
      this.rootScope.customerTabs,
      'customerSessionId',
      id
    );
    this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.SHOW, id);//CCR3-3401 
  }

  updateParentTab(id) {
    _.forEach(this.rootScope.customerTabs, (element) => {
      if (this.commonMethodFindId(element, this.parentData)) {
        element.additionalAccountId = id;
        this.parentData = null;
      }
      //element.iconClass='';
    });
  }


  openCustomerAccount(res, clientValue, buttonName) {



    let liveDetail = clientValue?.attributes;
    //clearning the customer search table once account is
    if (liveDetail) {
      this.rootScope.clearCustomerSearchState();
    }
    // open customer account research/live call/live
    if (
      this.rootScope.checkMaxCustAccount() &&
      (!buttonName || buttonName == Constants.buttonEnum.customerAccount) &&
      !this.rootScope.callFromSL1Tab) {
      this.holdingLiveData(liveDetail, res, clientValue);//holding live data application reach max limit tabs
    } else {
      let tab = this.createNewTabDTO(res, clientValue);
      this.openNewCustomerTab(tab, buttonName);
    }

    if (!this.rootScope.holdLiveDetails[0]?.id) this.routeToActiveTab();
    /**Below line of code added to get customer type in customer account dynamically from ALIS*/

    this.getAuthenticationMethods(this.rootScope.activeCustTab.clientId, this.rootScope.activeCustTab.customerType);
    // Updated for CCR3-721 &  CCR3-3830
    if (this.rootScope.isLiveCall || this.rootScope.checkLiveChatAccount()) {
      this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
    }
    setTimeout(() => {
      this.syncTabDataInElasticCache();
    }, 1000);




  }

  /**
   * This method is used to send customer tab details to backend service to save it in
   * elastic cache . This data will be used to restore accound in case system/browser is crashed
   */
  syncTabDataInElasticCache() {
    let payload;
    let tabdt = this.rootScope.activeCustTab;
    if (tabdt.conversationId != 'NA') {
      payload = {
        'customerSessionId': tabdt.customerSessionId,
        'conversationId': tabdt.conversationId,
        'cusTab': tabdt
      }
    }
    else {
      payload = {
        'customerSessionId': tabdt.customerSessionId,
        'cusTab': tabdt
      }
    }
    this.updateCustomerInElasticCache(payload);
    /**
     * In case of additional account both parent and child details needs to be updated
     */
    if (tabdt.additionalAccount) {
      let parentTab = this.getTabDetails(tabdt.parentId, tabdt.conversationId);
      payload = {
        'customerSessionId': parentTab?.customerSessionId,
        'cusTab': parentTab
      }
      // console.log('Updating parent tab data ');
      this.updateCustomerInElasticCache(payload);
    }

  }

  /**author Vamsi.pamidala
   * @liveDetail to verfiy the live call details with existing tab
   * To reduce api request calls in outbound call below method is created
   * @GenesysRes contain live ineracion attribute values and conversation Id 
   */
  outboundTab(GenesysRes) {
    this.logService.infoLogs("Method outboundTab called , GenesysRes = " + GenesysRes , this.className)
    let liveDetail = GenesysRes?.clientValue?.attributes;

    this.logService.infoLogs("Method outboundTab called , ActiveCustTab = " + this.rootScope.activeCustTab , this.className)
    let res = this.rootScope.activeCustTab?.tabData?.tabData;
    let approveException = this.rootScope.activeCustTab?.approvedExceptionsTypes;
    let approvedExceptionCredentialData = this.rootScope.activeCustTab?.approvedExceptionCredentialData;
    let approvedExceptionEgainContentData = this.rootScope.activeCustTab?.approvedExceptionEgainContentData;
    let approvedExceptionResouceLinksData = this.rootScope.activeCustTab?.approvedExceptionResouceLinksData;
    const personStatus = this.rootScope.activeCustTab.personStatus;

    let previouslyOpenedTab = _.findIndex(
      this.rootScope.customerTabs,
      (each) =>
        each.id == res?.globalPersonIdentifier &&
        each.conversationId == this.rootScope.conversationId
    );
    console.log("previouslyOpenedTab", previouslyOpenedTab)
    if (previouslyOpenedTab > 0) {
      //CCR3-6624 for CS pro transfer
      this.rootScope.patchGENAttribute.next({
        conversationId: GenesysRes?.conversationId,
        participantId: GenesysRes?.clientValue?.id,
        body: {
          attributes: {
            CS_XFER_USER_ID: this.rootScope.lanId,
            CS_INIT_REP_ID: this.rootScope.lanId,
            "PPT-NAME": res?.firstName + " " + res?.lastName,
            EMP: res?.employmentStatusCode
          }
        }
      });

      this.rootScope.activeCustTab = this.createNewTabDTO(res, GenesysRes?.clientValue);//
      this.rootScope.activeCustTab.IHBriefViewData = this.rootScope.customerTabs[previouslyOpenedTab]?.IHBriefViewData;//CCR3-4940
      this.rootScope.customerTabs[previouslyOpenedTab] =
        this.rootScope.activeCustTab;
      this.rootScope.activeCustTab.approvedExceptionsTypes = approveException;
      this.rootScope.activeCustTab.approvedExceptionCredentialData = approvedExceptionCredentialData;
      this.rootScope.activeCustTab.approvedExceptionEgainContentData = approvedExceptionEgainContentData;
      this.rootScope.activeCustTab.approvedExceptionResouceLinksData = approvedExceptionResouceLinksData;
      this.rootScope.activeCustTab.personStatus = personStatus;
      this.rootScope.activeCustTab.customerType = liveDetail?.CUSTOMER_TYPE;
      this.rootScope.customerLink = res['customer-session-id'];
      this.custAccService.getRepeatAlertStatus(this.rootScope.activeCustTab);
      // Updated for CCR3-721
      if (this.rootScope.isLiveCall) {
        this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
      }
      /**
       * @author Vamsi
       * based on secuirty level domain data will be differ 
       * Replaing entire customer account data when research account will convert into outbound call
       */
      let existingDataIndex = this.custAccService.customerAccountDt?.findIndex(x => x?.id == this.rootScope.activeCustTab?.customerSessionId);
      this.custAccService?.openNewCustAcc(this.rootScope.activeCustTab, existingDataIndex);
      this.accountFreezeService.getPrivacyPolicyStatus();
      try {
        this.timerService.updateTimerMapWithCustomerSessionId(this.rootScope.activeCustTab.customerSessionId);
      } catch (e) {
        /* istanbul ignore next */
        console.log("Error in method updateTimerMapWithCustomerSessionId ", e)
      }
      this.handleOutboundCallDialingOrConnected();
      let payload = {
        'customerSessionId': this.rootScope.activeCustTab.customerSessionId,
        'cusTab': this.rootScope.activeCustTab
      }

      this.updateCustomerInElasticCache(payload);
      this.getAuthenticationMethods(this.rootScope.activeCustTab.clientId, this.rootScope.activeCustTab.customerType);
      setTimeout(() => {
        this.updateCustTabStatus(true);
      }, 10);
    } else this.getPersonData(null, GenesysRes);
  }

  holdingDataValidation(liveDetail) {
    return (
      liveDetail &&
      (this.rootScope.isLiveCall ||
        (this.rootScope.isLiveChat &&
          !this.rootScope.holdLiveDetails.find(
            (xx) => xx?.id == liveDetail?.[Constants.ALS_chat.PrsnId]
          )))
    );
  }

  /**
   * @author VamsiKrishna
   * @param liveDetail 
   * @param res 
   * @param clientValue 
   * @returns 
   * Holding live call/chat details when application reach max tab in care portal 
   */
  holdingLiveData(liveDetail, res, clientValue) {
    if (this.holdingDataValidation(liveDetail)) {
      this.rootScope.holdLiveDetails.push(
        this.createNewTabDTO(res, clientValue)
      );
      if (this.rootScope.activeCustTab?.customerSessionId) {
        this.rootScope.customerLink =
          this.rootScope.activeCustTab.customerSessionId;
        this.routeToActiveTab(
          this.rootScope.activeCustTab?.customerSessionId
        );
      } else {
        this.rootScope.customerLink = 0;
        this.router.navigate(['/customer-search'], {
          skipLocationChange: true,
        });
      }
    }
    if (this.rootScope.holdLiveDetails?.length <= 1) return this.showPopup();
  }

  routeToActiveTab(id?) {
    console.log("route ", this.rootScope.activeCustTab.customerSessionId)
    this.router.navigate(
      [`/customer-account/${id ? id : this.rootScope.customerLink}`],
      {
        skipLocationChange: true,
      }
    );
  }

  tabSecurityDt(liveDetail, btn?) {
    let count = this.rootScope.activeChatOrCall(),
      _liveChat = this.rootScope.isLiveChat,
      _liveCall = this.rootScope.isLiveCall;
    let secuityDt = { iconClr: '', SL: '0', authenticateStatus: '' }; //sl:security level ,iconclr:tab icon colors
    // console.log('this.rootScope.isCallBackCall', this.rootScope.isCallBackCall);
    switch (true) {
      /**
       * Below 2 case are related to SL1 call from SL1 tab
       */
      case _liveCall &&
        (this.rootScope.isCallBackCall || (!this.liveCall?.ENC_CS_CUSTOMER_ID && !this.liveCall?.UDP_GBL_ID)) &&
        this.rootScope.callFromSL1Tab:
        secuityDt.iconClr = 'red';
        secuityDt.SL = '1';
        secuityDt.authenticateStatus = Constants.UNSECURED;
        break;
      case _liveCall &&
        this.rootScope.callFromSL1Tab && !this.rootScope.activeCustTab?.tabData:
        secuityDt.iconClr = 'red';
        secuityDt.SL = Constants.securityLevels.SL1;
        secuityDt.authenticateStatus = Constants.UNSECURED;
        break;


      case _liveCall && (count == 0 || btn == Constants.buttonEnum.replaceAccount || this.rootScope.activeCustTab?.tabData?.['identifiedCall']):
        /** Below code will  be executed for inbound /outbound call leave pro SL2 call */
        if (this.liveCall?.[Constants.ALS_LP_ATB] == Constants.ALS_Config_DesktopIndicator && this.liveCall['CallerSecurity'] == Constants.CallerSecurity.Identified) {
          secuityDt.iconClr = 'red';
          secuityDt.SL = Constants.securityLevels.SL2;
          secuityDt.authenticateStatus = Constants.UNSECURED;

        }
        else if (
          this.liveCall?.CS_SECURITY_LEVEL == '4' ||
          this.liveCall?.PINV == Constants.PINV_ATTRIBUTES.FULLY_SECURED_A ||
          this.liveCall?.PINV == Constants.PINV_ATTRIBUTES.FULLY_SECURED
        ) {
          secuityDt.iconClr = 'green';
          secuityDt.SL = Constants.securityLevels.SL4;
          secuityDt.authenticateStatus = Constants.FULLY_SECURED;
        }
        /** Below code will  be executed for inbound /outbound call  SL2 call */
        else if (
          (this.liveCall.CS_SECURITY_LEVEL == '2' ||
            (this.liveCall.PINV == Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED
              || this.liveCall.PINV == Constants.PINV_ATTRIBUTES.IDENTIFIED)) && this.liveCall.SSE != '3'
        ) {
          secuityDt.iconClr = 'red';
          // if (this.liveCall.ENC_CS_CUSTOMER_ID || this.liveCall.UDP_GBL_ID)
          secuityDt.SL = Constants.securityLevels.SL2
          // else {
          //   secuityDt.SL = Constants.securityLevels.SL1
          // }
          secuityDt.authenticateStatus = Constants.UNSECURED;
        }
        //Based on CCR3-9160
         else if ((
          this.liveCall.CS_SECURITY_LEVEL == '3' || this.liveCall.SSS == Constants.securityLevels.SL3 || this.liveCall.SSE == Constants.securityLevels.SL3
          || this.liveCall.PINV == Constants.PINV_ATTRIBUTES.PARTIALLY_SECURED
        ) && this.liveCall?.['CS_AUTH_CD']?.includes(Constants.AuthMenu.UAS)) {
          secuityDt.iconClr = 'green';
          secuityDt.SL = Constants.securityLevels.SL4;
          secuityDt.authenticateStatus = Constants.FULLY_SECURED;
         } /** Below code will  be executed for inbound /outbound call  leavePro SL4 call */
        else if (this.liveCall?.[Constants.ALS_LP_ATB] == Constants.ALS_Config_DesktopIndicator &&
          (this.liveCall?.CallerSecurity == Constants.CallerSecurity.Secured || this.liveCall?.CallerSecurity == Constants.CallerSecurity.AltSecured)) {
          secuityDt.iconClr = 'green';
          secuityDt.SL = Constants.securityLevels.SL4;
          secuityDt.authenticateStatus = Constants.FULLY_SECURED;
        } else {
          (secuityDt.iconClr = 'red'), (secuityDt.SL = '2');
          secuityDt.authenticateStatus = Constants.UNSECURED;
        }
        break;

      case liveDetail ? true : false:
        if (liveDetail && !_liveCall && liveDetail?.['PINV'] == Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED && this.liveChat?.CP_INDICATIVE_DATA_SECURED != 'true') {
          
          secuityDt.iconClr = _liveCall ? 'green' : 'solid red';
          secuityDt.SL = Constants.securityLevels.SL1;
          secuityDt.authenticateStatus = Constants.UNSECURED;
        }
        else {
          secuityDt.iconClr = _liveCall ? 'green' : 'solid green';
          secuityDt.SL = Constants.securityLevels.SL4;
          secuityDt.authenticateStatus = Constants.FULLY_SECURED;
        }
        break;
      case count > 0:
        secuityDt.iconClr = 'light';
        secuityDt.SL = Constants.securityLevels.SL4;
        secuityDt.authenticateStatus = Constants.Not_Applicable;
        break;

      default:
        secuityDt.iconClr = '';
        secuityDt.SL = Constants.securityLevels.SL0;
        secuityDt.authenticateStatus = Constants.Not_Applicable;
        break;
    }

    if ((secuityDt.SL == '2') && (this.liveCall?.CP_APPROVED_EXCPTION_SECURED == 'true' || this.liveCall?.CP_INDICATIVE_DATA_SECURED == 'true')) {
      secuityDt.iconClr = 'green';
      secuityDt.SL = '4';
      secuityDt.authenticateStatus = Constants.FULLY_SECURED;

    }

    return secuityDt;
  }

  idleTimeReset() {
    this.rootScope.activeCustTab.idle = false;
    this.updateidleInElasic(this.rootScope.activeCustTab.customerSessionId, false);
    this.updateIdle(
      this.rootScope.activeCustTab,
      this.rootScope.CCTConfigs.TIME_THRESHOLD_SUBSEQUENT
    );
  }

  updateidleInElasic(customerSessionId, type) {
    let payload = {
      'customerSessionId': customerSessionId,
      'cusTab': {
        'idle': type
      }
    }
    this.updateCustomerInElasticCache(payload);
  }
  /** @author Vamsi krishna
   * updateIdle to maintain timer alert in server level
   */

  updateIdle(tab, time) {
    setTimeout(() => {
      /* istanbul ignore next */
      this.rootScope.customerTabs.forEach((x) => {
        if (this.commonMethodFindId(x, tab)) {
          x.idle = true;
          this.updateidleInElasic(tab.customerSessionId, true);

        }
      });
    }, time * 60 * 1000);
  }

  updateOutboundCallInitiate(tabId, flag) {
    this.rootScope.customerTabs.forEach((x) => {
      if (x.customerSessionId == tabId) {
        x.outboundCallInitiate = flag;
      } else {
        x.outboundCallInitiate = false;
      }
    });
  }

  getCustomerRoute() {
    return this.csAcRouting.asObservable();
  }

  updateCustTabStatus(active) {
    _.filter(this.rootScope.customerTabs, {
      active: active,
      activeChat: false,
      activeCall: false,
    }).forEach((element) => {
      element.active = !active;
      //element.iconClass='';
    });
  }

  /**
   * @author:Pooja
   * story No :CCR1-7970
   */
  getPropertyMapping(){
    let params = { propertyNames: Constants.ATTRIBUTE_PROPERTY_NAME_CALL +","
                                  + Constants.ATTRIBUTE_PROPERTY_NAME_OFFMODE + ","
                                  + Constants.ATTRIBUTE_PROPERTY_NAME_STOP_TEXT_OPT_IN +","
                                  + Constants.ATTRIBUTE_PROPERTY_NAME_CHAT +","
                                  + Constants.ATTRIBUTE_PROPERTY_NAME_SCREEN_POP+","
                                  + Constants.ATTRIBUTE_PROPERTY_NAME_CSPRO_TRANSFER_SUPPORT };
    this.apiService.getApi(Global.GET_CLIENT_MAPPING_NEW, params, 'false', false).subscribe({
      next: (data: any) => {
        /* istanbul ignore next */
        if (data && data?.data){
          this.setPropertNameCallData(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_CALL])
          /* istanbul ignore next */
          this.setPropertyNameOffModeData(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_OFFMODE]);
          /* istanbul ignore next */
          this.setPropertyNameChatData(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_CHAT]);
          /* istanbul ignore next */
          this.setPropertyNameScreenPopup(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_SCREEN_POP]);
          /* istanbul ignore next */
          this.setPropertyNameCSProTransferSupport(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_CSPRO_TRANSFER_SUPPORT]);
          /* istanbul ignore next */
          this.setPropertyNameStopTextOptInData(data?.data[Constants.ATTRIBUTE_PROPERTY_NAME_STOP_TEXT_OPT_IN]);
          
        }
      },
      error: (error) => {
        console.log('getClientMapping API error = ', error);
      },
    });
  }

  /**
   * 
   * @param propertyName  = "ALS-OFFCALL"
   * @author :Pooja  : CCR5-729
   */

   setPropertyNameChatData(mainData) {
    if(mainData && mainData != null)
       this.rootScope.createMapForProperyName(mainData, this.rootScope.chatClientConfig)
    else{
       /* istanbul ignore next */
      this.logService.errorLogs("Getting and setting ALS Off Data failed",this.className);
    }
 }

 /** CCR5-729*/
 setPropertNameCallData(mainData) {
  if(mainData && mainData != null)
     this.rootScope.createMapForProperyName(mainData, this.rootScope.callClientConfig);
  else{
     /* istanbul ignore next */
    this.logService.errorLogs("Getting and setting ALS Call Data failed",this.className);
  }
}

/** CCR5-729*/
 setPropertyNameOffModeData(mainData) {
  if(mainData && mainData != null)
     this.rootScope.createMapForProperyName(mainData, this.rootScope.researchAttributeMap)
  else{
    /* istanbul ignore next */
    this.logService.errorLogs("Getting and setting ALS Off Data failed",this.className);
  }
 }

/**CCR3-7385 */
 setPropertyNameCSProTransferSupport(mainData) {
  if(mainData && mainData != null)
     this.rootScope.createMapForProperyName(mainData, this.rootScope.CSProTransferConfig)
  else{
     /* istanbul ignore next */
    this.logService.errorLogs("Getting and setting data for propertyName Screen CSPro Transfer failed",this.className);
  }
 }

 /** CCR1-13755 */
 setPropertyNameStopTextOptInData(mainData) {
  if(mainData && mainData != null)
     this.rootScope.createMapForProperyName(mainData, this.rootScope.stopTextOptInConfig)
  else{
     /* istanbul ignore next */
    this.logService.errorLogs("Getting and setting data for propertyName Stop Text Opt-In failed",this.className);
  }
 }

 setPropertyNameScreenPopup(mainData) {
  if(mainData && mainData != null)
     this.rootScope.createMapForProperyName(mainData, this.rootScope.screenPopConfig)
  else{
     /* istanbul ignore next */
    this.logService.errorLogs("Getting and setting Screen Popup Data failed",this.className);
  }
 }


  
  /**
   * To get clients for login user
   */

  getClientDetails() {
    try {

      this.getClientMapping();
      this.getPropertyMapping();

      // this.getAttributeMapping(Constants.ATTRIBUTE_PROPERTY_NAME_SCREEN_POP, this.rootScope.screenPopConfig);

      /**Getting attribute Map for research Mode CCR5-729 */
      // this.getAttributeMapping(Constants.ATTRIBUTE_PROPERTY_NAME_OFFMODE, this.rootScope.researchAttributeMap);

      this.apiService
        .getApi(Global.customerApi.clientResponseList, null, 'false', true)
        .subscribe({
          next: (res) => {
            /* istanbul ignore next */
            if (res) {
              res = this.apiService.errorValidation(res);
              // this.logService.log(res);
              // sessionStorage.setItem(
              //   this.rootScope.sessionId + 'clientList',
              //   JSON.stringify(res.clientResponseList)
              // );
              // console.log('clientResponseList::' + JSON.stringify(res.clientResponseList));
              this.clients =
                res.clientResponseList?.length > 0
                  ? res.clientResponseList
                  : [{ clientId: '0', clientName: 'None - selected' }];
              this.rootScope.sortedClientList = this.clients;
              if (!this.rootScope.dashboardForm.get('clientNameDash')?.value || this.rootScope.dashboardForm.get('clientNameDash')?.value == '0') {
                this.rootScope.sortedClientList = this.clients;
                this.rootScope.sortedClientList.sort((a, b) => {
                  // Convert clientName to lowercase for case-insensitive comparison
                  const nameA = a.clientName.toLowerCase();
                  const nameB = b.clientName.toLowerCase();

                  if (nameA < nameB) {
                    return -1; // Name A comes before Name B
                  } else if (nameA > nameB) {
                    return 1; // Name A comes after Name B
                  } else {
                    return 0; // Names are equal
                  }
                });

                //this.rootScope.dashboardForm.setValue({ clientNameDash: this.rootScope.sortedClientList[0].clientName });
                //this.rootScope.dashboardForm.setValue({ clientId: this.rootScope.sortedClientList[0]?.clientId});

                this.rootScope.dashboardForm.get('clientNameDash')?.setValue(this.rootScope.sortedClientList[0].clientName ? this.rootScope.sortedClientList[0].clientName : '');
                this.rootScope.dashboardForm.get('clientId')?.setValue(this.rootScope.sortedClientList[0].clientId ? this.rootScope.sortedClientList[0].clientId : '');


                // console.log('setclient::' + this.rootScope.dashboardForm.get('clientId')?.value);

              };
              // console.log('dashboardForm::' + this.rootScope.dashboardForm.get('clientId')?.value);
              /**
               * Getting all Client Mapping data for each client 
               */
              // if (this.clients?.length > 0 && this.clients[0].clientId != 0) {
              //   this.clients.forEach(x => {
              //     if (x?.clientId) {
              //       this.custAccService.getTransId(x);
              //     }
              //   })
              // }
              this.rootScope.getDashboardLeftNavData({ value: this.rootScope.getClientId(this.rootScope.dashboardForm.get('clientNameDash')?.value) });
              this.rootScope.getDashboardMyTodo({ value: this.rootScope.getClientId(this.rootScope.dashboardForm.get('clientNameDash')?.value) });
              this.appointmentsCardService.getDashboardMyAppointments({ value: this.rootScope.getClientId(this.rootScope.dashboardForm.get('clientNameDash')?.value) });
            }
          },
          error: (err) => { console.log(err); }
          // this.clients  =  _.filter(this.clients, (each) => each.clientId != "P0095");
        });
    } catch (error) {
      /* istanbul ignore next */
      console.log(error);
    }

  }

  getClientMapping() {
    this.apiService.getApi(Global.GET_CLIENT_MAPPING, null, 'false', false).subscribe({
      next: (data: any) => {
        console.log('getClientMapping API data = ', data);
        if (data && data?.data)
          this.rootScope.clientSystemIds = data?.data;
      },
      error: (error) => {
        console.log('getClientMapping API error = ', error);
      },
    });
  }

 
      
/* istanbul ignore next */
  getChatPropertyMapping() {
    try {
      let params = { propertyName: Constants.ATTRIBUTE_PROPERTY_NAME_CHAT };

      this.apiService.getApi(Global.GET_USER_CLIENT_PROPERTY, params, 'false', false).subscribe({
        next: (data: any) => {
          /* istanbul ignore next */
          if (data && data?.data) {
            let mainData = data?.data;

            Object.keys(mainData).forEach(x => {
              if (mainData?.[x]?.propertyValue) {
                try {
                  mainData[x]['parsedObjectData'] = JSON.parse(mainData[x]?.propertyValue);
                  this.rootScope.chatClientConfig.set(x, mainData[x]['parsedObjectData']);
                } catch (error) {
                  this.logService.error(error);
                  this.rootScope.chatClientConfig.set(x, null);
                }
              }
            })
          }
        },
        error: (error) => {
          console.log('getClientMapping API error = ', error);
        },
      });
    } catch (error) {

    }

  }

  /* istanbul ignore next */
  getScreenPopMapping() {
    let params = { propertyName: Constants.ATTRIBUTE_PROPERTY_NAME_SCREEN_POP };
    this.apiService.getApi(Global.GET_USER_CLIENT_PROPERTY, params, 'false', false).subscribe({
      next: (data: any) => {
        /* istanbul ignore next */
        if (data && data?.data) {
          let mainData = data?.data;

          Object.keys(mainData).forEach(x => {
            if (mainData?.[x]?.propertyValue) {
              try {
                mainData[x]['parsedObjectData'] = JSON.parse(mainData[x]?.propertyValue);
                this.rootScope.screenPopConfig.set(x, mainData[x]['parsedObjectData']);
              } catch (error) {
                this.logService.error(error);
                this.rootScope.screenPopConfig.set(x, null);
              }
            }
          })
        }
      },
      error: (error) => {
        console.log('getClientMapping API error = ', error);
      },
    });
  }
  /**
   * CCR3-7385
   * to get CS pro transfer call mapping ids
   */
  getCSProTRANSMapping() {
    let params = { propertyName: Constants.ATTRIBUTE_PROPERTY_NAME_CSPRO_TRANSFER_SUPPORT };
    this.apiService.getApi(Global.GET_USER_CLIENT_PROPERTY, params, 'false', false).subscribe({
      next: (data: any) => {
        
        if (data && data?.data) {
          let mainData = data?.data;

          Object.keys(mainData).forEach(x => {
            if (mainData?.replaceAccountProcess?.[x]?.propertyValue) {
              try {
                mainData[x]['parsedObjectData'] = JSON.parse(mainData[x]?.propertyValue);
                this.rootScope.CSProTransferConfig.set(x, mainData[x]['parsedObjectData']);
              } catch (error) {
                this.logService.error(error);
                this.rootScope.CSProTransferConfig.set(x, null);
              }
            }
          })
        }
      },
      error: (error) => {
        console.log('getClientMapping API error = ', error);
      },
    });
  }



  mustCloseAddionalPopup(page?, id?) {
    this.rootScope.openCustomDialog(
      id
        ? Constants.Close_Account_Chat_Msg
        : Constants.Additional_Account_Chat_Msg,
      'NA',
      Constants.CANCEL_BUTTON_TYPE,
      page ? Constants.CUSTOMER_ACNT : Constants.CUSTOMER_SEARCH,
      Constants.CLOSE_ADD_ACNT_BUTTON,
      Constants.CLOSE_ADD_ACNT_BUTTON,
      'additional-account'
    );
  }

  closeAddAccount() {
    let index = this.rootScope.customerTabs.findIndex((x) =>
      this.commonMethodFindId(x, this.openAdditonalAcc)
    );

    if (index) {
      this.closeCustomerTbaScreens(this.rootScope.customerTabs[index]);
      /*istanbul ignore next */
      this.closeAccountApiReq(this.rootScope.customerTabs[index]); //to maintain interaction histroy api request
      this.rootScope.customerTabs.splice(index, 1); //Delete the additional account customer account
    }

    this.rootScope.customerTabs.forEach((x) => {
      if (
        x.additionalAccountId == this.openAdditonalAcc?.id &&
        x.conversationId == this.openAdditonalAcc?.conversationId
      ) {
        x.additionalAccountId = '';
        x.isAdditionalAccOpen = '';
      }
    });
    this.intHistService.deleteEntryIHMap(this.openAdditonalAcc?.customerSessionId);
    this.custAlertsService.deleteEntryCustAlertMap(this.openAdditonalAcc?.customerSessionId);
    this.intHistService.transferredDataArr = [];
    this.openAdditonalAcc = null;

  }

  /*@author Vamsi.pamidala
  to maintain Interaction history in AWS SQS and DataBase CCR1-1180 */

  closeAccountApiReq(tab: Tab) {
    try {
      this.clearCustAccCache(tab);
      let res = tab?.tabData?.tabData,
        date = this.rootScope.dateFormatter(tab?.startTime, 'yyyy-MM-dd');
      let parentDetails = tab?.tabData?.parentData;
      this.interactionModel = {
        // _id: null,
        begin: new Date(tab?.startTime)?.toISOString(), // this.rootScope.dateFormatter(tab.startTime, Constants.timeZone.intraction),//'yyyy-MM-ddThh:mm:ss.SSSZ'
        end: new Date().toISOString(), //this.rootScope.dateFormatter(new Date(), Constants.timeZone.intraction),
        system: 'careportal',
        subject: {
          id: tab?.id,
          firstName: res?.firstName,
          lastName: res?.lastName,
          // type: tab?.defaultRole,
        },
        clientId: this.checkClientSystemMappingAndReplace(tab?.clientId),
        channel: tab?.channel,
        externalRefId: tab?.conversationId,
        created: new Date(tab?.startTime)?.toISOString() || new Date().toISOString(),
        description: tab.reasonForAdditional?.firstReason,
        details: tab?.reasonForAdditional?.secondReason ? tab.reasonForAdditional?.secondReason : 'N/A',
        initiated:
          tab.tabData?.direction == 'outbound' ? Constants.IH_INTERNAL_CALL : Constants.IH_EXTERNAL_CALL,
        contact: {
          name: parentDetails ? parentDetails.title : '',
          id: parentDetails?.id,
          type: parentDetails?.customerType, // ? this.rootScope.customerTypeData.find(xx => xx?.fieldValue == parentDetails.customerType)?.fieldValueDescription : "NA",
          phoneNumber:
            tab.channel == Constants.conversion.chat
              ? 'N/A'
              : parentDetails?.tabData?.phoneNumber?.slice(4),
          emailAddress: 'N/A',
          ipAddress: 'N/A',
          role: tab?.defaultRole
        },
        delegate: {
          name: this.rootScope.firstName + ' ' + this.rootScope.lastName,
          delegateId: this.rootScope.lanId,
          phoneNumber: 'N/A',
          emailAddress: this.rootScope.emailId,
          telephonyId : localStorage.getItem(Constants.TELEPHONY_ID) || this.rootScope.activeCustTab?.telephonyId
        },
        buckets: []
      };

// ✅ Clean up blank values
  this.removeIHBlankValues(this.interactionModel);

      this.awsService.sendInteractionHistoryToSQS(this.interactionModel);
      //this.parentData = null;
    } catch (error) {
      this.logService.error(error);
    }
  }
removeIHBlankValues(interactionModel: any): void {
  const values = ['emailAddress', 'phoneNumber', 'ipAddress','telephonyId'];
  const wrapupdata = interactionModel.buckets?.find(x => x?.keyName == 'wrapUpData')?.keyValue;
  values.forEach((value) => {
    if (interactionModel?.contact?.[value] === 'N/A' || interactionModel?.contact?.[value] === '') {
      delete interactionModel.contact[value];
    }
  });

  values.forEach((value) => {
    if (interactionModel?.delegate?.[value] === 'N/A' || interactionModel?.delegate?.[value] === '') {
      delete interactionModel.delegate[value];
    }
  });
  if (wrapupdata) {
    if (wrapupdata.interactionFeedback === '') {
      delete wrapupdata.interactionFeedback;
    }
    delete wrapupdata.callStatus;

    if(wrapupdata?.wrapupTopicList?.length == 0){
      delete wrapupdata.wrapupTopicList;
    }
  }
  
}
  clearCustAccCache(tab) {
    this.deleteCustomerInElasticCache(tab?.customerSessionId);
    if (tab?.tabData?.parentData) {
      let payload = {
        'customerSessionId': tab?.tabData?.parentData.customerSessionId,
        'cusTab': {
          'additionalAccountId': '',
          'isAdditionalAccOpen': ''
        }
      }
      this.updateCustomerInElasticCache(payload);
    }
    this.custAccService.customerAccountDt =
      this.custAccService.customerAccountDt.filter(
        (item) => item?.id != tab.customerSessionId
      );
  }
  //Max Account limit
  showPopup() {
    if (!this.rootScope.isModelopen) {
      this.rootScope.isModelopen = true;
      this.rootScope.openDialog({
        title: '',
        subheading: '',
        message: Constants.Max_Account_Msg,
        firstbutton: '',
        secondbutton: Constants.buttonEnum.gotIt,
        crossIcon: false,
        comingFrom: Constants.comptFrom.Max_Account,
        additionalClass: Constants.comptFrom.Max_Account,
      });

    }
  }

  //MAdditional Account popup
  showAdditionalPopup() {
    this.rootScope.openDialog({
      title: '',
      subheading: '',
      message:
        'One Additional Account is already opened with this account. Close it to open another Additional Account.',
      firstbutton: '',
      secondbutton: Constants.buttonEnum.gotIt,
      crossIcon: false,
      comingFrom: Constants.comptFrom.Max_Account,
      additionalClass: Constants.comptFrom.Max_Account,
    });
  }

  //static development of Showing popup CCR6-1432 
  //prevent customer to close account tab CCR1-95

  closeCustomeraccount() {
    if (this.rootScope.customerTabs.length > 1) {
      this.rootScope.openDialog({
        title: '',
        subheading: '',
        message: "This customer’s account could not be closed. Review and action any alerts, then try again.",
        firstbutton: '',
        secondbutton: "Ok",
        crossIcon: false,
        comingFrom: '',
        additionalClass: 'clsoeAcoount-modal',
      });
    }
  }



  /**@author vamsikrishna
   * when user close or navigate time find based on id and converstion id
   */
  commonMethodFindId(x, tab) {
    return x.id == tab?.id && x.conversationId == tab?.conversationId;
  }

  getTabDetails(id, conversationId) {
    return this.rootScope.customerTabs.find(
      (x) => x.id == id && x.conversationId == conversationId
    );
  }

  getClientName(clientId) {
    let obj = _.find(this.clients, function (each) {
      return each.clientId == clientId;
    });
    return obj ? obj.clientName : '';
  }


  /**
   * This method is used to send customer tab details to backend service to save it in
   * elastic cache . This data will be used to restore accound in case system/browser is crashed
   * 
   * @param payload 
   */
  updateCustomerInElasticCache(payload) {
    this.updateCustomerInElasticCacheObs(payload).subscribe({
      next: () => {
        this.rootScope.logMessage(Constants.INFO, 'updateCustomerInElasticCache Data successfully updated in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      },
      error: (error) => {
        this.rootScope.logMessage(Constants.ERROR, 'updateCustomerInElasticCache Error while updating data in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      }
    })
  }

  updateCustomerInElasticCacheObs(payload): Observable<any> {

    return this.http.post(Global.domainUrl + Global.UPDATE_CUSTOMER_EC, payload, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),

    });
  }

  deleteCustomerInElasticCache(customerSessionId) {
    if (!customerSessionId) {
      this.logService.errorLogs("customer session is missing from the request process", this.className);
    }
    else {
      this.deleteCustomerInElasticCacheObs(customerSessionId).subscribe({
        next: () => {
          this.rootScope?.logMessage(Constants.INFO, 'deleteCustomerInElasticCache Customer Datat successfully updated in EC for CustomerSessionId: ' + customerSessionId);
        },
        error: (error) => {
          this.rootScope?.logMessage(Constants.ERROR, 'deleteCustomerInElasticCache Error while deleting customer in EC for CustomerSessionId: ' + customerSessionId);
        }
      })
    }
  }

  deleteCustomerInElasticCacheObs(customerSessionId): Observable<any> {
    // CCR3-11850 Penetration Testing Sensitive Data Remediation
    // let url = Global.domainUrl + Global.DELETE_CUSTOMER_EC;

    let reqbody = { customerSessionId: customerSessionId };
    return this.http.delete(Global.domainUrl + Global.DELETE_CUSTOMER_EC, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      body: reqbody,
    });

  }

  closeCustomerTbaScreens(tab) {
    //Close TBA screens related to customer start
    let tbaClosePayload = this.rootScope.tbaPayloadMap?.get(tab?.customerSessionId);
    /* istanbul ignore next */
    if (tbaClosePayload) {
      tbaClosePayload.action = Constants.TBA_CLOSE_PERSON;
      this.tbaService.callTbaApi(tbaClosePayload);
      this.rootScope.tbaPayloadMap.delete(tab?.customerSessionId);
    }
    // Close TBA screens related to customer end
  }

  getAuthenticationMethods(clientId, customerType) {
    this.rootScope.activeCustTab.authenticationContents.authenticationAPIfailure = false;
    this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = false;
    this.rootScope.activeCustTab.authenticationContents.selectedAuthenticationContent = [];
    const actTab = this.rootScope?.activeCustTab;

    const authenticationData = _.find(actTab.authenticationContents, (x) => {
      return x?.customerType === actTab?.customerType;
    });

    if (authenticationData) {
      this.rootScope.activeCustTab.authenticationContents.selectedAuthenticationContent = authenticationData?.authenticationContents;
    }
    else {
      this.getAuthenticationContents(clientId, customerType);
    }

  }

  /**
  * This method is used to send customer tab details to backend service to save it in
  * elastic cache . This data will be used to restore accound in case system/browser is crashed
  * @param payload 
  */
  getAuthenticationContents(clientId, customerType) {
    this.rootScope.activeCustTab.authenticationContents.authenticationAPIfailure = false;
    this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = false;
    this.rootScope.activeCustTab.authenticationContents.selectedAuthenticationContent = [];

    if (this.rootScope.activeCustTab.IS_AAAS_ENABLED) {
        this.aaaSService.getAaasUserAuthMethod(true);
    }
    else {
    this.getAuthenticationContentsObs(clientId, customerType).subscribe({
      next: (res) => {
        /* istanbul ignore next */
        if (res && res?.data?.length > 0) {

          const resData = {
            clientId: this.rootScope.activeCustTab.clientId,
            customerType: this.rootScope.activeCustTab.customerType,
            authenticationContents: res?.data
          };

          if(!this.rootScope.activeCustTab.IS_AAAS_ENABLED){
          this.rootScope.activeCustTab.authenticationContents.push(resData);
          this.rootScope.activeCustTab.authenticationContents.selectedAuthenticationContent = res?.data;
          
          this.rootScope.logMessage(Constants.INFO, 'getAuthenticationContentList successfully called for clientId:' + clientId + ' and customerType: ' + customerType);
          }
        }
        else {
          this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = true;
          let emptyAuthEgainContent = {
            name: '',
            content: ''
          }
          this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = emptyAuthEgainContent;

        }
      },
      error: (error) => {
        this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = true;
        this.rootScope.logMessage(Constants.ERROR, 'updateCustomerInElasticCache Error while updating data in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      }
    });
  }
  }


  getAuthenticationContentsObs(clientId, customerType): Observable<any> {

    let url = Global.domainUrl + Global.authenticationApis.gethenticationContentList + '?clientId=' + clientId + '&customerType=' + customerType;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

  }

  /**
   * 
   * @param response 
   * @returns 
   */
  /* istanbul ignore next */
  decryptPlatformExternalIds(response) {
    response?.udpSearchResponseList?.forEach((res) => {
      if (res?.platformExternalId?.length > 12)
        res.platformExternalId = this.encryptDecryptService.decrypt(res?.platformExternalId);
    });
    return response;
  }

  /* istanbul ignore next */
  closeCustomerDocuments(tab) {

    if (this.rootScope.customerTbaDocumentsMap.has(tab?.customerSessionId)) {
      const port = sessionStorage.getItem('tba_port');
      const sessionId = sessionStorage.getItem('tba_sessionId');
      let groupName = tab?.customerSessionId;
      const url = `https://${this.rootScope.hostName}:${port}/doc/${sessionId}/${groupName}`;
      const req = new XMLHttpRequest();
      req.open("DELETE", url);
      req.send();
      this.rootScope.customerTbaDocumentsMap.delete(tab?.customerSessionId)
    }

  }
  /** 
   * @author VamsiKrishna
   * update elastic cache data from any where
   */
  updateCustData() {
    this.rootScope.updateElasticData.subscribe((x) => {
      if (x) {
        this.updateCustomerInElasticCache(x);
      }
    })
  }

  /**
   * Leave pro work
   * @param isClientPresent 
   * @returns 
   */
  leavProCallValidation(isClientPresent) {
    return (isClientPresent && this.liveCall?.[Constants.ALS_LP_ATB] == Constants.ALS_Config_DesktopIndicator);
  }
  /**
   * 
   * @param attribute live chat attributes
   * to validate the chat is it leave pro chat or not 
   * @returns true/false based conditions 
   */
  leavProChatValidation(attribute) {
    return ((attribute?.[Constants.ALS_chat.PMT] == Constants.ALS_Config_DesktopIndicator || attribute?.[Constants.ALS_chat.chat_PMT] == Constants.ALS_Config_DesktopIndicator || attribute?.[Constants.ALS_chat.ChatTopic] == Constants.ALS_Config_DesktopIndicator));

  }
  /**
   * 
   * @returns true for leave pro validation 
   */
  leaveProvalidation() {
    return (this.leavProCallValidation(true) || this.leavProChatValidation(this.liveChat));
  }

  /* istanbul ignore next */
  getCustomerDataForLP(data) {
    try {
      let ALS_ATTRIBUTE_VALUE, UDP_ATTRIBUTE_NAME;
      let targetSystemVal;

      // live Call details update for leave PRO
      if (this.rootScope.isLiveCall) {
        ALS_ATTRIBUTE_VALUE = this.liveCall?.[this.rootScope.callAttributes?.[Constants.conversationConfig.ALS_ATTRIBUTE]];
        UDP_ATTRIBUTE_NAME = this.rootScope.callAttributes?.[Constants.conversationConfig.UDP_ATTRIBUTE];
        /** Adding below line as a part of CCR1-6616
         * this.liveCall?.['TargetSystem'] = "AM360 " OR "LP";
         */
        targetSystemVal = this.liveCall?.['TargetSystem'];
      }
      // live Chat details update for leave PRO
      else if (this.rootScope.isLiveChat) {
        if (!this.liveChat?.['TargetSystem']) {
          targetSystemVal = "LP";
        }
        else {
          targetSystemVal = this.liveChat?.['TargetSystem'];
        }

        ALS_ATTRIBUTE_VALUE = this.liveChat?.[this.rootScope.chatAttributes?.[Constants.conversationConfig.ALS_ATTRIBUTE]];
        UDP_ATTRIBUTE_NAME = this.rootScope.chatAttributes?.[Constants.conversationConfig.UDP_ATTRIBUTE];
      }



      if (UDP_ATTRIBUTE_NAME?.includes(Constants.ALIS_ATTRIBUTE_NAMES.PLATFORMEXTERNALID)) {
        if (targetSystemVal) {
          let payload = {
            clientId: this.liveClient,
            platformExternalId: ALS_ATTRIBUTE_VALUE,
            systemInstanceId: targetSystemVal
          }
          this.getCustomerDataBasedEID(data, payload);
        }
        else {
          this.dynamicATT[0] = Constants.ALIS_ATTRIBUTE_NAMES.PLATFORMEXTERNALID; this.dynamicATT[1] = ALS_ATTRIBUTE_VALUE;
          this.getPersonData(null, data);
        }
      }
      else if (UDP_ATTRIBUTE_NAME?.includes(Constants.ALIS_ATTRIBUTE_NAMES.globalIdentifierId)) {
        this.dynamicATT[0] = Constants.ALIS_ATTRIBUTE_NAMES.globalIdentifierId; this.dynamicATT[1] = ALS_ATTRIBUTE_VALUE;
        this.getPersonData(null, data);

      }
      else if (UDP_ATTRIBUTE_NAME?.includes(Constants.ALIS_ATTRIBUTE_NAMES.PLATFORMINTERNALID)) {
        this.dynamicATT[0] = Constants.ALIS_ATTRIBUTE_NAMES.PLATFORMINTERNALID; this.dynamicATT[1] = ALS_ATTRIBUTE_VALUE;
        this.getPersonData(null, data);

      }
      else if (UDP_ATTRIBUTE_NAME?.includes(Constants.ALIS_ATTRIBUTE_NAMES.WORKERID)) {
        let payload = {
          clientId: this.liveClient,
          employeeId: ALS_ATTRIBUTE_VALUE,
          systemInstanceId: targetSystemVal
        }
        this.getCustomerDataBasedEID(data, payload);
      }

      else this.invalidUDPID(data);
    } catch (error) {
      console.log(error);
    }

  }

  getCustomerDataBasedEID(data, model) {
    try {

      this.apiService
        .postApi(Global.customerApi.fetchCustomerData, model, false, Constants.apiVersions, false)
        .subscribe({
          next: (res) => {
            /* istanbul ignore next */
            if (res) {

              res = this.apiService.errorValidation(res);

              if (res?.udpSearchResponseList?.length == 1) {
                this.dynamicATT = ['globalIdentifierId', res?.udpSearchResponseList[0].udpId]
                this.getPersonData(null, data);
                // this.timerService.startTimerAtCallLand(data.clientValue?.connectedTime);
              }
              else {
                this.parseAndIdentifyPPT(res?.udpSearchResponseList, model, data);
              }

            }

          },
          error: (error) => {
            /* istanbul ignore next */
            console.log(error);
            /* istanbul ignore next */
            this.handleUnIdentifiedCall();
          }
        })
    } catch (error) {
      console.log(error);
    }
  }


  /**
   * Below method handle  the case where multiple records are coming 
   * 1 emplId and systemInstanced in case of workerId searchresult.
   * Matching the response and trying to identify the ppt
   * if found launching CA
   * If not launching unknown caller - CCR1-6616
   * @param respArr 
   * @param payload 
   * @param data 
   */

  parseAndIdentifyPPT(respArr, payload, data) {
    if (payload?.employeeId) {
      let pptIdentified: boolean = false;
      for (let i = 0; i < respArr?.length; i++) {
        let eachPPT = respArr[i];
        let trimeedEmpId = this.rootScope.trimLeadingZeroes(eachPPT?.employeeId);
        let trimPayloadEmpId = this.rootScope.trimLeadingZeroes(payload?.employeeId);
        if (trimeedEmpId == trimPayloadEmpId) {
          pptIdentified = true;
          this.dynamicATT = ['globalIdentifierId', eachPPT.udpId]
          this.getPersonData(null, data);
          break;
        }
      }

      if (!pptIdentified) {
        /**Since ppt unidentified redirecting to unknown page */
        this.invalidUDPID(data);
      }
    }
    else {
      /**Since ppt unidentified redirecting to unknown page */
      this.invalidUDPID(data);
    }


  }
  /**
   * 
   * @param data 
   * @param udpId 
   */
  updateALSAttribute(data, udpId) {

    if (this.rootScope.isLiveCall && this.leavProCallValidation(true)) {
      this.rootScope.patchGENAttribute.next({ conversationId: data.conversationId, participantId: data.clientValue?.id, body: { attributes: { UDP_GBL_ID: udpId } } })

    } else if (this.rootScope.isLiveChat && this.leavProChatValidation(this.liveChat)) {
      this.rootScope.patchGENAttribute.next({ conversationId: data.conversationId, participantId: data.clientValue?.id, body: { attributes: { 'context.glblPrsnId': udpId } } })
    }
  }
  /**Below method handle the call event and check if the Genesys Outbound Call in dialing mode and
   * then assigned the live call tab outboundCallDialing  variable to true and also update it in elastic cache  */
  handleOutboundCallDialingOrConnected() {
    this.logService.infoLogs("Method handleOutboundCallDialingOrConnected called", this.className)
    this.rootScope.outboundCallDialingSub = this.rootScope.genesysNotificationCall.subscribe({
      next: (genesysObj: any) => {
        let liveCallAccount: any = this.rootScope?.customerTabs.find(
          (x) => x?.activeCall == true
        );

        this.logService.debugLogs("Method handleOutboundCallDialingOrConnected called , liveCallAccount = " + liveCallAccount, this.className)
        if (liveCallAccount) {
          if (this.getOutBoundCallState(genesysObj) == Constants.ALIS_Live_Status.dialing) {
            liveCallAccount.outboundCallDialing = true;
            let payload = {
              customerSessionId: liveCallAccount?.customerSessionId,
              cusTab: liveCallAccount
            }
            //this.updateCustomerInElasticCache(payload);//CCR5-753
          }
        }

      },
      error: (error) => { },
    });
  }

  /**Below method Open the Recording Pop-Up when the outbound call gets connected */
  /* istanbul ignore next */
  openRecordingDialPopUp() {
    this.rootScope.outboundCallConnectedSub = this.rootScope.genesysNotificationCall.subscribe({
      next: (genesysObj: any) => {

        let liveCallAccount: any = this.rootScope?.customerTabs.find(
          (x) => x?.activeCall == true
        );
        const liveConnectedOutboundUser = genesysObj?.eventBody?.participants?.find(
          (x) =>
            x?.['purpose'] === 'customer' &&
            x?.['state'] === Constants.ALIS_Live_Status.connected &&
            x?.['direction'] == 'outbound');

        if (liveCallAccount) {
          if (this.getOutBoundCallState(genesysObj) == Constants.ALIS_Live_Status.connected) {
            this.timerService.startTimerAtCallLand(liveConnectedOutboundUser?.connectedTime);
            this.rootScope.activeCustTab.conversationConnectedTime = this.timerService.connectedTime;

            if (!this.rootScope.outBoundPopUp) { this.custAccService.openRecordDialog();
              if (!this.rootScope.activeCustTab.Config_DesktopIndicator) {
                this.liveCall[Constants.ALS_LP_ATB] = liveConnectedOutboundUser.attributes?.[Constants.ALS_LP_ATB];
                this.rootScope.activeCustTab.Config_DesktopIndicator = liveConnectedOutboundUser.attributes?.[Constants.ALS_LP_ATB];
              }
             }
            if (liveCallAccount.outboundCallDialing) {
              liveCallAccount.outboundCallDialing = false;
              let payload = {
                customerSessionId: liveCallAccount?.customerSessionId,
                cusTab: liveCallAccount
              }
              if (liveCallAccount.id != 1) this.updateCustomerInElasticCache(payload);//CCR5-753
            }
            this.rootScope.outboundCallConnectedSub.unsubscribe();
            this.rootScope.outboundCallDialingSub.unsubscribe();

          }
        }
      },
      error: (error) => { },
    });
  }

  /**
   * 
   * @param payload update tab sl values when user authMethod
   */
  updateTabSL(payload) {

    let tabIndex = this.custAccService?.customerAccountDt?.findIndex(
      (x) => x?.id == this.rootScope?.activeCustTab?.customerSessionId
    );

    // updating database & reloading
    /* istanbul ignore next */
    this.updateCustomerInElasticCacheObs(payload).subscribe({
      next: () => {

        this.custAccService?.openNewCustAcc(this.rootScope.activeCustTab, tabIndex);
        this.rootScope.logMessage(Constants.INFO, 'updateCustomerInElasticCache Data successfully updated in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      },
      error: (error) => {
        this.rootScope.logMessage(Constants.ERROR, 'updateCustomerInElasticCache Error while updating data in EC for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId);
      }
    })


  }

  /**
   * Retrieves the state of the outbound call from the provided Genesys object.
   * @param genesysObj The Genesys object containing information about the call.
   * @returns The state of the outbound call ('dialing', 'connected', or an empty string if not found).
   */
  getOutBoundCallState(genesysObj: any): string {
    const outboundCustomer = genesysObj?.eventBody?.participants?.find(x =>
      x?.purpose === 'customer' && x?.direction === 'outbound');

    return outboundCustomer?.state || '';
  }

  



  /**
   * 
   * @param GenesysRes 
   * @param idMapping
   * //CCR3-7385 
   * Updated to handle both TBA and CBA clients for platformExternalId assignment.
   * Preference: If both TBA and CBA exist, pick platformExternalId platformType TBA.
   */
  
  updateCSProPayloads(GenesysRes, res) {
    try {
      const idMapping = res?.idMapping;
      let model = {
        attributes: {
          CS_XFER_USER_ID: this.rootScope.lanId,
          CS_INIT_REP_ID: this.rootScope.lanId,
          "PPT-NAME": res?.firstName + " " + res?.lastName,
          EMP: res?.employmentStatusCode
        }
      };

      if (!this.rootScope.validateNullAndEmpty(this.liveCall?.ENC_CS_CUSTOMER_ID) && idMapping?.length) {
        let platformExternalId = "";


        // Handle TBA and CBA separately, and combination
        const hasTBA = idMapping.some(x => x.platformType.includes('TBA'));
        const hasCBA = idMapping.some(x => x.platformType.includes('CBA'));

        if(idMapping.length == 1) {
          platformExternalId = idMapping[0].platformExternalId;
        }
        else if (hasTBA && hasCBA) {
          // Combination: Prefer platform with TBA
          platformExternalId = this.getPlatformExternalIdByType('TBA', idMapping, platformExternalId);
        } else if (hasTBA) {
          platformExternalId = this.getPlatformExternalIdByType('TBA', idMapping, platformExternalId);
        } else if (hasCBA) {
          platformExternalId = this.getPlatformExternalIdByType('CBA', idMapping, platformExternalId);
        }
        
        if (platformExternalId) {
          model.attributes['IS_CS_CUSTOMER_ID_ENCRYPTED'] = true;
          model.attributes['ENC_CS_CUSTOMER_ID'] = this.encryptDecryptService.encodeAndEncrypt(platformExternalId);
        }
      }
      this.rootScope.patchGENAttribute.next({ conversationId: GenesysRes?.conversationId, participantId: GenesysRes?.clientValue?.id, body: model });
      this.logService.infoLogs("UpdateCSProPayloads as " + JSON.stringify(model), this.className);
    } catch (error) {
      this.logService.errorLogs("UpdateCSProPayloads failed", this.className);
    }
  }

  // Helper to get platformExternalId by type and config priority
  getPlatformExternalIdByType = (type: string, idMapping: any, platformExternalId: string) => {
    const filtered = idMapping.filter(x => x.platformType.includes(type));
    if (filtered.length === 1) {
      return filtered[0].platformExternalId;
    } else if (filtered.length > 1) {
      // Check for duplicates
      let counts = {};
      for (let i = 0; i < filtered.length; i++) {
        if (counts[filtered[i].platformExternalId]) {
          counts[filtered[i].platformExternalId] += 1;
        } else {
          counts[filtered[i].platformExternalId] = 1;
        }
      }
      if (Object.keys(counts)?.length !== filtered.length) {
        // Find most repeated
        return Object.keys(counts).reduce((a, b) => (counts[a] > counts[b]) ? a : b);
      } else {
        // Use config priority
        let configKey = Constants.ATTRIBUTE_CSPRO_TRANSFER_SUPPORT;
        let CSProTransferAttrConfig = this.rootScope.CSProTransferConfig.get(this.liveClient);
        let CSProTransferBaseConfig = this.rootScope.CSProTransferConfig.get("BASE");
        let Config = (CSProTransferAttrConfig ? CSProTransferAttrConfig : CSProTransferBaseConfig)?.[configKey]?.split('|') || [];
        for (let i = 0; i < Config.length; i++) {
          if (!platformExternalId && filtered.find(x => x.domains?.includes(Config[i]))) {
            return filtered.find(x => x.domains?.includes(Config[i]))?.platformExternalId;
          }
        }
      }
    }
    return "";
  };

  /**
   * @author VamsiKrishna
   * CCR3-11164
   * Updates the PPT-NAME and employment status attributes for a given Genesys conversation participant.
   *
   * @param GenesysRes - The response object containing Genesys conversation details, including conversationId and participant information.
   * @param res - The object containing user details such as firstName, lastName, and employmentStatusCode.
   *
   * @throws Will log an error if the update operation fails.
   */
  updatePPT_NAME(GenesysRes, res) {
    try {
      let model = {
        attributes:
        {
          "PPT-NAME": res?.firstName + " " + res?.lastName,
          "EMP": res?.employmentStatusCode
        }
      };
      this.rootScope.patchGENAttribute.next({ conversationId: GenesysRes?.conversationId, participantId: GenesysRes?.clientValue?.id, body: model });
      this.logService.infoLogs("Update PPT_NAME as "+res?.firstName + " " + res?.lastName+"and EMP as"+ res?.employmentStatusCode, this.className);
    } catch (error) {
      this.logService.errorLogs("UpdatePPT_NAME failed",this.className);
    }
  }

  /**
   * @author VamsiKrishna
   * Validates the line of business for the given Genesys response.
   * 
   * This method checks if the `liveClient` exists and if it is not already present in the `authMethodConfig`.
   * If not present, it fetches the authentication content list from the API and updates the `authMethodConfig`.
   * Once the configuration is updated, it calls the `authMethodConfigCheck` method with the provided Genesys response.
   * 
   * @param GenesysRes - The response object from Genesys that needs to be validated.
   */
  validateLineofBusiness(GenesysRes) {
  
    if (this.liveClient && !this.rootScope.authMethodConfig.has(this.liveClient)) {
      this.apiService.getApi(Global.authenticationApis.gethenticationContentList, { clientId: this.liveClient }, 'false', false).subscribe({
        next: (res) => {
          if (res?.data) {
            res.data.forEach((element, index) => {
              if (element?.platformSupport) {
                try {
                  res.data[index].platformSupport = JSON.parse(element?.platformSupport);
                } catch (error) {
                  res.data[index].platformSupport = {};
                  console.error('Error in parsing platformSupport', error);
                }
              }
            });
            setTimeout(() => {
              this.rootScope.authMethodConfig.set(this.liveClient, res.data);
              this.authMethodConfigCheck(GenesysRes);
            }, 100);

          }
        },
        error: (error) => {
          console.log("error in getAuthMethods", error);
        },

      });
    } else {
      this.authMethodConfigCheck(GenesysRes);
    }
  }

  /**
   * Checks the authentication method configuration based on the provided Genesys response.
   * 
   * @param {any} GenesysRes - The response object from Genesys containing client values and attributes.
   * 
   * @throws Will log an error message if an exception occurs during the execution of the method.
   * 
   * @remarks
   * This method performs the following steps:
   * 1. Extracts attributes from the Genesys response.
   * 2. Determines the desktop indicator and caller type from the attributes.
   * 3. Retrieves the indicative data configuration based on the caller type.
   * 4. Checks if the desktop indicator is included in the platform support inclusion or exclusion lists.
   * 5. Calls `getPersonDataAPI` with the appropriate parameters based on the configuration and attributes.
   * 6. Logs an error message if an exception occurs.
   */
  authMethodConfigCheck(GenesysRes) {
    try {


      const attributes = GenesysRes?.clientValue?.attributes;
      const desktopIndicator = attributes?.Config_DesktopIndicator;
      const callerType = attributes?.CUSTOMER_TYPE || attributes?.CS_CALLER_TYPE||Constants.defaultCaller;
      const indicativeDataConfig = this.rootScope.authMethodConfig?.get(this.liveClient)?.find(x =>
        x?.securityMethodCode == Constants.AuthMenu.IND_DATA && x.customerType == callerType);
      const indicativeDataConfigDesktop = indicativeDataConfig?.platformSupport?.INCLUSION?.includes(desktopIndicator) || indicativeDataConfig?.platformSupport?.INCLUSION?.includes('*');
      const indicativeDataConfigExclusion = indicativeDataConfig?.platformSupport?.EXCLUSION && !indicativeDataConfig?.platformSupport?.EXCLUSION?.includes(desktopIndicator);

      if (indicativeDataConfig && (indicativeDataConfigDesktop || indicativeDataConfigExclusion)) {
        this.getPersonDataAPI(null, GenesysRes, null);
      }
      else if (attributes && (attributes?.CP_INDICATIVE_DATA_SECURED == 'true'||this.liveCall?.['CS_AUTH_CD']?.includes(Constants.AuthMenu.UAS))) {
        attributes['CP_INDICATIVE_DATA_SECURED'] = "false";
        attributes.CS_SECURITY_LEVEL = Constants.securityLevels.SL2;
        attributes.CS_AUTH_CD = "";
        GenesysRes.clientValue.attributes = attributes;
        if (this.liveCall?.CallerSecurity) this.liveCall.CallerSecurity = Constants.CallerSecurity.Identified;
        this.liveCall = attributes;
        this.getPersonDataAPI(null, GenesysRes, null);
      }
      else this.getPersonDataAPI(null, GenesysRes, null);
    } catch (error) {
      /* istanbul ignore next */
      this.logService.infoLogs("authMethodConfigCheck Method Getting error", this.className);
    }
  }

 

// CCR3-10820
  handleAuthCode(tab, x, data) {
    if (data?.[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA] && this.rootScope.isLiveCall) {
      let AUTH_METHODS;
      try {
        AUTH_METHODS = JSON.parse(data[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA])?.['authMethods'];
        if (AUTH_METHODS && AUTH_METHODS.length > 0) {
        tab.genesysAttributes[x] = Constants.AuthCode[AUTH_METHODS[0]];
        tab.authChannel = Constants.AUTH_CHANNELS.IVR;
      }
      }
      catch (error) {
      // Handle error in parsing CIM_DATA
        this.logService.errorLogs('Error parsing in authMethods: ' + data[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA]?.['authMethods'], this.className);
        tab.genesysAttributes[x] = '';
        tab.authChannel = '';
      }
     
    }

    else {
      // EA : call is secured in IVR through DOB, SSN or postal
      //CCTS-37134 - In case of missing authMethods in CIM_DATA attribute, 
      
      tab.genesysAttributes[x] = Constants.AuthCode.EA;
      tab.authChannel = Constants.AUTH_CHANNELS.IVR;
    }
  }

    openDesktopIndicatorDialog() {
    this.rootScope.desktopIndicatorModel=true;

    this.rootScope.openDialog({
      title: 'Call Not Recognized Due to Missing Indicator',
      subheading: 'Please read to customer:',
      message: Constants.Inbound_Call_Error_Msg,
      CCRNote:Constants.Inbound_Call_Task_Msg, 
      firstbutton: "",
      secondbutton: Constants.buttonEnum.acknowledge,
      crossIcon: false,
      comingFrom: 'customer-account',
      additionalClass: 'record-modal',
       id: 'desktop-indicator-missing'
    });
  }

  

  ngOnDestroy() {
    this.liveClient = null; // Clear liveClient on destroy
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
    this.rootScope.outboundCallConnectedSub.unsubscribe();
    this.rootScope.outboundCallDialingSub.unsubscribe();
  }



}

